import {EventEmitter, Injectable, Output} from '@angular/core';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {catchError,retry,shareReplay,map} from 'rxjs/operators';
// import { _throw as throwError } from 'rxjs/observable/throw'; // only way to ge throwError to work.
// import {Observable} from 'rxjs';


import {MyobContact } from './models/myob-contacts.model';
import { MyobServiceInvoice } from './models/myob-service-invoice.model';
import { MyobServicePaymentInvoice } from './models/myob-service-invoice-payment.model';
import { MyobServicePurchase } from './models/myob-service-purchase.model';
import { MyobServicePaymentWorkOrder } from './models/myob-service-work-order-payment.model';
import {
  ActivityMetricsV2ExportResponse,
  ActivityMetricsV2Response,
  ActivityMetricsV2Search,
  ActivityMetricsV2StoreCleanupResponse,
  ActivityMetricsV2StoreSetupResponse,
  ActivityMetricsV2StoreStatus,
  ActivityMetricsV2StoreSyncResponse
} from './shared/models/activity-metrics-v2.model';
// import { environment } from './environments/environment';
import { environment } from '../environments/environment';
import { StaffWeightedWorkReport, StaffWeightedWorkSearch } from './shared/models/staff-weighted-work.model';
import { StaffAchievementReport, StaffAchievementSearch } from './shared/models/staff-achievement.model';

export interface MyobAuthStatus {
  connected: boolean;
  granularReady: boolean;
  authorizationType: string;
  businessId: string | null;
  businessName: string | null;
  configuredBusinessId: string | null;
  businessIdMatches: boolean;
  requiredScopes: string[];
  grantedScopes: string[];
  authorisedAt: string | null;
  lastUpdated: string | null;
  refreshTokenLastUpdated: string | null;
  accessTokenExpiresAt: string | null;
  accessTokenExpired: boolean | null;
}

export interface MyobRefreshResult extends MyobAuthStatus {
  refreshed: boolean;
  message: string;
}

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const httpOptions2 = {
  headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
};

@Injectable({
  providedIn: 'root'
})
export class DemoService {

  model: any;
    // $api_get_url = 'https://api.nickbowen.com.au';
    $api_get_url = environment.$api_get_url;

    $api_url = 'https://digitalgoblet.com/slim-crud/public';

    // tslint:disable-next-line:member-ordering
    // $api_get_sopNode = 'https://sopnode.teqnick.com'; // LIVE SOPNode Server for SOP myob interactions
    $api_get_sopNode = environment.sopNodeURL;  // REMEMBER LIVE SERVER HAS TO BE ON THE SAME DOMAIN AS SOP!!!!!!


    $api_get_adobeAPI = environment.adobeAPIURL;  // REMEMBER LIVE SERVER HAS TO BE ON THE SAME DOMAIN AS SOP!!!!!!
    error_message: any;
    error_message_standard: any;
    error_name: any;
    full_response_data: any;
    data_sent: any;
    data_sent_id: any;
    response_from_node: string;
    response_from_node_raw: any;
    
    // Local -- HTTP:// not ssl!
    // $api_get_sopNode = "http://localhost:1050";

// Myob Responses
        // sees if there is a change in myCount
        @Output() change: EventEmitter<any> = new EventEmitter<any>();
        // New event emitter to show the results of api calls to other modules from this component as sendResponse() results.. set response_from_node
          @Output('sendResponse') sendResponse: EventEmitter<any> = new EventEmitter();
          @Output() test_message: EventEmitter<any> = new EventEmitter<any>();


    constructor(private http: HttpClient) {}


    // Uses http.get() to load data from a single API endpoint
        getCustomers() {
                return this.http.get(this.$api_get_url + '/api/customers');
            }

            createCustomer(customer) {
                let body = JSON.stringify(customer);
                 return this.http.post(this.$api_get_url + '/api/customer/add', body, httpOptions);
              }
  
           updateCustomer(customer) {
                  let body = JSON.stringify(customer);
                  return this.http.put(this.$api_get_url + '/api/customer/update/' + customer.id, body, httpOptions);
              }
  
          deleteCustomer(customer) {
                 return this.http.delete(this.$api_get_url + '/api/customer/delete/' + customer.id, httpOptions2);
              }
  

              deleteJobType(job_type_id) {
                return this.http.delete(this.$api_get_url + '/api/job_type/delete/' + job_type_id, httpOptions2);
             }

             
  

             deleteSystemLogType(log_type_id) {
                return this.http.delete(this.$api_get_url + '/api/system_log_type/delete/' + log_type_id, httpOptions2);
             }

             deleteSystemLogTypeDataSectorType(log_type_data_sector_type_id) {
                return this.http.delete(this.$api_get_url + '/api/system_log_type_data_sector_type/delete/' + log_type_data_sector_type_id, httpOptions2);
             }

             deleteSystemLogTypeDataSectorCondition(log_type_data_sector_condition_id) {
                return this.http.delete(this.$api_get_url + '/api/system_log_type_data_sector_condition/delete/' + log_type_data_sector_condition_id, httpOptions2);
             }

             

             deleteSystemLogTypeDataSector(log_type_data_sector_id) {
                return this.http.delete(this.$api_get_url + '/api/system_log_type_data_sector/delete/' + log_type_data_sector_id, httpOptions2);
             }


             deleteSubjectServiceOutcomeTemplate(ssot_id) {
                return this.http.delete(this.$api_get_url + '/api/subject_service_outcome_template/delete/' + ssot_id, httpOptions2);
             }



/* Old Function
              getUsers() {
                return this.http.get(this.$api_get_url + '/api/users');
            }
*/
            getUsers() {
                // return this.http.get('https://digitalgoblet.com/slim-crud/public/users');
                 return this.http.get(this.$api_get_url + '/api/users');
                // return this.http.get('https://digitalgoblet.com/slim-crud/public/users', httpOptions);
            }


            getUsersById(user) {
                return this.http.get(this.$api_get_url + '/api/user/' + user );
               // return this.http.get('http://digitalgoblet.com/slim-crud/public/user/' + user );
                //return this.http.get(this.$api_get_url + '/api/user/2');
            }


                        getUsersByUsernameEmail(model) {
                return this.http.get(this.$api_get_url + '/api/user_b/username/' + model.first_name + '_' + model.surname + '/email/' + model.personal_email_address );
               // return this.http.get('http://digitalgoblet.com/slim-crud/public/user/' + user );
                //return this.http.get(this.$api_get_url + '/api/user/2');
            }




                // Returns user data for a given user ID
                getUserById_promise(userId: number): Promise<any> {
                return this.http.get(this.$api_get_url + `/api/user/${userId}`).toPromise();
                }


            getFormUserLevels() {
                 return this.http.get(this.$api_get_url + '/api/form/user_levels');
                // return this.http.get('https://digitalgoblet.com/slim-crud/public/api/user_levels');
            }

            getUserLevels() {
                return this.http.get(this.$api_get_url + '/api/form/user_levels/all');
           }

           getUserLevel(level) {
            return this.http.get(this.$api_get_url + '/api/user/level/' + level);
       }

                // table used to store all the ATS companies and profiles
            getBrands(): Observable<any> {
                return this.http.get<any>(this.$api_get_url + '/api/brands').pipe(retry(3),
                shareReplay()
                )};


            getBrandById(brand_id) {
                return this.http.get(this.$api_get_url + '/api/brands/get/' + brand_id );
            }


            updateUsers(user) {
                let body = JSON.stringify(user);
               // console.log(user);
               // console.log(body);
              //  console.log(httpOptions);
              //  console.log('Field: user_id: ' + user.user_id);
              //  console.log('Field id: ' + user.id);
               // return this.http.put(this.$api_get_url + '/api/user/update2/' + user.user_id, body, httpOptions);
               // return this.http.put('https://digitalgoblet.com/slim-crud/public/user/update/' + user.id, body, httpOptions2);
                return this.http.put(this.$api_get_url + '/api/user/update/' + user.user_id, body, httpOptions);
            }


/* 
* START OF TRACE
*/

getTraces() {
    return this.http.get(this.$api_get_url + '/api/traces');
}


searchTrace() {
    return this.http.get(this.$api_get_url + '/api/trace/search');
}


getTraceTypes()
{
    return this.http.get(this.$api_get_url + '/api/trace/types')
}

getTraceType(trace_type_id)
{
    return this.http.get(this.$api_get_url + '/api/trace/types/get/' + trace_type_id)
}


createTrace(model)
{
    let body = JSON.stringify(model);
    console.log(body);
    return this.http.post(this.$api_get_url + '/api/trace/create', body, httpOptions);
    /// Maybe get the vars here and then rediect the page from the actual component.
}


createCustome0000000r(customer) {
    let body = JSON.stringify(customer);
     return this.http.post(this.$api_get_url + '/api/customer/add', body, httpOptions);
  }

createTraceCandidate(model)
{
    let body = JSON.stringify(model);
    console.log('Should be Body of model?');
    console.log(body);
   return this.http.post(this.$api_get_url + '/api/trace/candidate/create/' + model.trace_id, body, httpOptions);
   // return true;
    /// Maybe get the vars here and then rediect the page from the actual component.
}


getTraceById(trace) {
    return this.http.get(this.$api_get_url + '/api/trace/'  + trace );
}



getTraceStatus()
{
    return this.http.get(this.$api_get_url + '/api/trace/trace_status')
}

getTraceStatusdById(trace_status_id) {
    return this.http.get(this.$api_get_url + '/api/trace/trace_status/get/'  + trace_status_id );
}

getTraceNumberLatest() {
    return this.http.get(this.$api_get_url + '/api/trace/number/latest');
}

getTraceCandidates(trace_id) {
    return this.http.get(this.$api_get_url + '/api/trace/candidates/'  + trace_id );
}

// get a single candidate
getTraceCandidate(trace_candidate_id) {
     return this.http.get(this.$api_get_url + '/api/trace/candidate/get/' + trace_candidate_id);
}

updateTraceCandidate(model) {
    let body = JSON.stringify(model);
    console.log(model);
    console.log( 'CandidateID: ' + model.trace_candidate_id);

    return this.http.put(this.$api_get_url + '/api/trace/candidate/update/' + model.trace_candidate_id, body, httpOptions);
}



// Start Trace Candidate Timings and Statistics

startTraceCandidate(model) {
    let body = JSON.stringify(model);
    console.log(model);
    // console.log( 'CandidateID: ' + model.trace_candidate_id);

    return this.http.put(this.$api_get_url + '/api/trace/candidate/start/' + model.trace_candidate_id, body, httpOptions);
}


closeTraceCandidate(model) {
    let body = JSON.stringify(model);
    // console.log(model);
    // console.log( 'CandidateID: ' + model.trace_candidate_id);

    return this.http.put(this.$api_get_url + '/api/trace/candidate/close/' + model.trace_candidate_id, body, httpOptions);
}


reopenTraceCandidate(model) {
    let body = JSON.stringify(model);
    return this.http.put(this.$api_get_url + '/api/trace/candidate/reopen/' + model.trace_candidate_id, body, httpOptions);
}




updateTrace(model) {
    let body = JSON.stringify(model);
    console.log(model);
    console.log( 'TraceID: ' + model.trace_id);

    return this.http.put(this.$api_get_url + '/api/trace/update/' + model.trace_id, body, httpOptions);
}



// candidates

getTraceLocateStatus()
{
    return this.http.get(this.$api_get_url + '/api/trace/trace_locate_status')
}



deleteTraceCandidate(trace_candidate_id) {
    return this.http.delete(this.$api_get_url + '/api/trace/candidate/delete/'
     + trace_candidate_id);
 }

// Create a Brand
createBrand(model){
    let body = JSON.stringify(model);
    // console.log(model);
   return this.http.put( this.$api_get_url + '/api/brand/create/new', body, httpOptions);
}
// end Brand Manager


// Create a Brand
createBrandPrimary(model){
    let body = JSON.stringify(model);
    // console.log(model);
   return this.http.put( this.$api_get_url + '/api/brand/create/new/primary', body, httpOptions);
}
// end Brand Manager

updateBrand(model) {
    let body = JSON.stringify(model);
   // console.log(model);
    return this.http.put(this.$api_get_url + '/api/brand/update/' + model.brand_id, body, httpOptions);
}

updateBrandMyobDetails(model, brand_id, myob_id) {
    let body = JSON.stringify(model);
   // console.log(model);
    return this.http.put(this.$api_get_url + '/api/brand/update/myob_details/' + brand_id + '/' + myob_id, body, httpOptions);
}

 /// MANAGER  COMPONENT WITH LOGIN


 // -- BrandClientManager
 getBrandClients(brand_id) {
    return this.http.get(this.$api_get_url + '/api/client_brands/get/'  + brand_id );
}
getBrandClient(client_brand_id) {
    return this.http.get(this.$api_get_url + '/api/client_brand/get/'  + client_brand_id );
}
updateBrandClient(model) {
    let body = JSON.stringify(model);
   // console.log(model);
    return this.http.put(this.$api_get_url + '/api/client_brand/update/' + model.client_brand_id, body, httpOptions);
}
createBrandClient(model)
{
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/client_brand/create/' + model.brand_id, body, httpOptions);
}



// -- BrandClientContactsManager
getBrandClientContacts(brand_id, client_brand_id) {
    return this.http.get(this.$api_get_url + '/api/client_contacts/get/' + brand_id + '/'  + client_brand_id );
}
BrandClientContact(id) {
    return this.http.get(this.$api_get_url + '/api/client_contact/get/'  + id );
}
updateBrandClientContacts(model) {
    let body = JSON.stringify(model);
    // console.log(model);
    return this.http.put(this.$api_get_url + '/api/client_contact/update/' + model.id, body, httpOptions);
}
createBrandClientContact(model){
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/client_contact/create/' + model.client_brand_id, body, httpOptions);
}

// single
getBrandClientContact(client_brand_id) {
    // /api/client_brand/get/{client_brand_id}
    return this.http.get(this.$api_get_url + '/api/client_brand/get/' + client_brand_id  );
}

updateBrandClientContact(model) {
    // /api/client_brand/update/{client_brand_id}
    let body = JSON.stringify(model);
     return this.http.put(this.$api_get_url + '/api/client_brand/update/' + model.client_brand_id, body, httpOptions);
}



// -- BrandUserManager
getBrandUsers(brand_id) {
    return this.http.get(this.$api_get_url + '/api/brand/users/get/'  + brand_id );
}

getBrandUsersByLevel(brand_id, access_level) {
    return this.http.get(this.$api_get_url + '/api/brand/users/getByLevel/'  + brand_id + '/' + access_level);
}


getBrandUsersAgents() {
    return this.http.get(this.$api_get_url + '/api/brand/users/agents/get');
}



getBrandUser(user_id) {
    return this.http.get(this.$api_get_url + '/api/brand/user/get/'  + user_id );
}
updateBrandUser(model) {
    let body = JSON.stringify(model);
   // console.log(model);
    return this.http.put(this.$api_get_url + '/api/brand/user/update/' + model.user_id, body, httpOptions);
}


setUserForceLogout(model, user_id, force_logout) {
    let body = JSON.stringify(model);
   // console.log(model);
    return this.http.put(this.$api_get_url + '/api/user/set/force_logout/' + user_id + '/' + force_logout, body, httpOptions);
}

setUserForceLogoutGlobal(model, user_id, force_logout) {
    let body = JSON.stringify(model);
   // console.log(model);
    return this.http.put(this.$api_get_url + '/api/global/set/force_logout/' + force_logout, body, httpOptions);
}


setUserTFAResetGlobal(model, user_id, is_tfa_setup_passed) {
    let body = JSON.stringify(model);
   // console.log(model);
    return this.http.put(this.$api_get_url + '/api/global/reset/tfa/' + is_tfa_setup_passed, body, httpOptions);
}



setUserForceLogoutSoft(model, user_id, force_logout_soft) {
    let body = JSON.stringify(model);
   // console.log(model);
    return this.http.put(this.$api_get_url + '/api/user/set/force_logout_soft/' + user_id + '/' + force_logout_soft, body, httpOptions);
}


setUserForceLogoutGlobalSoft(model, user_id, force_logout_soft) {
    let body = JSON.stringify(model);
   // console.log(model);
    return this.http.put(this.$api_get_url + '/api/global/set/force_logout/soft/' + force_logout_soft, body, httpOptions);
}


createBrandUser(model){
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/brand/user/create/' + model.brand_id, body, httpOptions);
}
// end Brand Manager

// Candiate Full View (gets status - did not really need)
getTraceCandidateStatusdById(status_id) {
    return this.http.get(this.$api_get_url + '/api/trace/candidate/status/get/'  + status_id );
}

// Put command
updateBrandUserPasswordHash(model) {
    let body = JSON.stringify(model);
   // console.log(model);
    return this.http.put(this.$api_get_url + '/api/brand/user/password_hash/update/' + model.user_id, body, httpOptions);
}


// Client Traces

getCLIENTTraces(user_id, brand_id) {
    return this.http.get(this.$api_get_url + '/api/CLIENT/traces/'  + user_id + '/' + brand_id);
}

getCLIENTClientBrands(brand_id) {
 // /api/CLIENT/client/brands/{brand_id}
    return this.http.get(this.$api_get_url + '/api/CLIENT/client/brands/'  + brand_id );

}






// Put command
updateBrandPasswordKeyHash(model) {
    let body = JSON.stringify(model);
   // console.log(model);
    return this.http.put(this.$api_get_url + '/api/brand/global_key_hash/update/' + model.brand_id, body, httpOptions);
}

getBrandPasswordKeyHash(model) {
    return this.http.get(this.$api_get_url + '/api/brand/global_key_hash/read/'  + model.brand_id );
}
getFilePasswordKeyHash(model) {
    return this.http.get(this.$api_get_url + '/api/file/global_key_hash/read/'  + model.file_id );
}



// assinged or allocated traces
getTraceAssigned(trace_id) {
    return this.http.get(this.$api_get_url + '/api/trace/assign/'  + trace_id );
}


// Insert a Single Assigned User Drop Down
createTraceAssigedUser(item, trace_id, user_id) {
    let body = JSON.stringify(item);
    return this.http.post( this.$api_get_url + '/api/trace/assign/create/' + trace_id, body, httpOptions);

}

// Insert Multiple Users
createTraceAssigedUserMultiple(items, trace_id) {
    let body = JSON.stringify(items);
    return this.http.post( this.$api_get_url + '/api/trace/assign/create/multiple/' + trace_id, body, httpOptions);
}

// Remove a single when checked (as a put)
deleteTraceAssigned(item, trace_id, user_id) {
    let body = JSON.stringify(item);
    // console.log(model);
     return this.http.put(this.$api_get_url + '/api/trace/assign/delete/' + trace_id + '/' + user_id, body, httpOptions);
}


// Remove all from assigned trace
deleteTraceAssignedAll(trace_id) {
    return this.http.delete(this.$api_get_url + '/api/trace/assign/delete/all/' + trace_id );
}



// Create Trace Statistics

/*
createTraceStats(item, trace_id) {
}*/


getTraceCandidatesAll(trace_id){
    // /api/trace/candidates/stats/all/{trace_id}
    return this.http.get(this.$api_get_url + '/api/trace/candidates/stats/all/' + trace_id  );
}

getTraceCandidatesL(trace_id){
     // /api/trace/candidates/stats/l/{trace_id}
     return this.http.get(this.$api_get_url + '/api/trace/candidates/stats/l/' + trace_id  );
}

getTraceCandidatesPL(trace_id){
    // /api/trace/candidates/stats/pl/{trace_id}
    return this.http.get(this.$api_get_url + '/api/trace/candidates/stats/pl/' + trace_id  );
}

getTraceCandidatesNL(trace_id){
    // /api/trace/candidates/stats/nl/{trace_id}
    return this.http.get(this.$api_get_url + '/api/trace/candidates/stats/nl/' + trace_id  );
}

getTraceCandidatesAllOpen(trace_id){
    // /api/trace/candidates/stats/all/open/{trace_id}
    return this.http.get(this.$api_get_url + '/api/trace/candidates/stats/all/open/' + trace_id  );
}

getTraceCandidatesAllAll(trace_id){
    // /api/trace/candidates/stats/all/all/{trace_id}
    return this.http.get(this.$api_get_url + '/api/trace/candidates/stats/all/all/' + trace_id  );
}




// Start A trace Instructions and Settings
startTrace(model) {
    // /api/trace/start/{trace_id}
    let body = JSON.stringify(model);
    return this.http.put(this.$api_get_url + '/api/trace/start/' + model.trace_id, body, httpOptions);
}

// Start A trace Instructions and Settings
startTraceDropdown(trace_id, user_id) {
    // /api/trace/start/dropdown/{trace_id}/{user_id}
   // let body = JSON.stringify(model);
    return this.http.put(this.$api_get_url + '/api/trace/start/dropdown/' + trace_id + '/' + user_id, httpOptions);
}



closeTrace(model) {
    // /api/trace/close/{trace_id}
    let body = JSON.stringify(model);
    return this.http.put(this.$api_get_url + '/api/trace/close/' + model.trace_id, body, httpOptions);
}


refreshTrace(model) {
    // /api/trace/close/{trace_id}
    let body = JSON.stringify(model);
    return this.http.put(this.$api_get_url + '/api/trace/refresh/' + model.trace_id, body, httpOptions);
}

reopenTrace(model) {
    // /api/trace/reopen/{trace_id}
    let body = JSON.stringify(model);
    return this.http.put(this.$api_get_url + '/api/trace/reopen/' + model.trace_id, body, httpOptions);

}


// Brand traces stats

getTracesByBrandL(brand_id) {
     // /api/trace/brand/stats/l/{brand_id}
     return this.http.get(this.$api_get_url + '/api/trace/brand/stats/l/' + brand_id  );
}

getTracesByBrandAll(brand_id){
    // /api/trace/brand/stats/all/{brand_id}
    return this.http.get(this.$api_get_url + '/api/trace/brand/stats/all/' + brand_id  );
}



getClientBrands(brand_id) {
    // /api/brands/clientbrands/{{brand_id}}
    return this.http.get(this.$api_get_url + '/api/brands/get/clientbrands/' + brand_id  );
}

getClientBrand(client_brand_id) {
    // /api/brand/get/clientbrand/{client_brand_id}
    return this.http.get(this.$api_get_url + '/api/brand/get/clientbrand/' + client_brand_id  );
}




getTracesByClientBrandAll(client_brand_id){
    // /api/trace/brand/client/stats/all/{client_brand_id}
    return this.http.get(this.$api_get_url + '/api/trace/brand/client/stats/all/' + client_brand_id  );
}


getBrandClientContactsAll(client_brand_id){
    // /api/clientcontacts/get/all/{client_brand_id}
    return this.http.get(this.$api_get_url + '/api/clientcontacts/get/all/' + client_brand_id  );
}

getTracesByUserAll(user_id){
    // /api/trace/user/stats/all/{user_id}
    return this.http.get(this.$api_get_url + '/api/trace/user/stats/all/' + user_id  );
}


getTracesGlobalAll(){
    // /api/trace/global/stats/all/
    return this.http.get(this.$api_get_url + '/api/trace/global/stats/all'  );
}

getTracesGlobalStatusAll(status){
    // /api/trace/global/stats/all/{status}
    return this.http.get(this.$api_get_url + '/api/trace/global/stats/all/' + status  );
}

getTracesGlobalAllLive(){
    // /api/trace/global/stats/live/all
    return this.http.get(this.$api_get_url + '/api/trace/global/stats/live/all');
}



getTracesGlobalUserStatusAll(status, user_id){
    // /api/trace/global/stats/user/{status}/{user_id}
    return this.http.get(this.$api_get_url + '/api/trace/global/stats/user/' + status + '/' + user_id  );
}

getTracesGlobalStaffStatusAll(status, user_id){
    // /api/trace/global/stats/staff/{status}/{user_id}
    return this.http.get(this.$api_get_url + '/api/trace/global/stats/staff/' + status + '/' + user_id  );
}


getTracesGlobalUserAllLive(user_id){
    // /api/trace/global/stats/user/live/all/{user_id}
    return this.http.get(this.$api_get_url + '/api/trace/global/stats/user/live/all/' + user_id);
}


getTracesGlobalStaffAllLive(user_id){
    // /api/trace/global/stats/staff/live/all/{user_id}
    return this.http.get(this.$api_get_url + '/api/trace/global/stats/staff/live/all/' + user_id);
}

getTracesGlobalStaffAll(user_id){
    // /api/trace/global/staff/stats/all/{user_id}
    return this.http.get(this.$api_get_url + '/api/trace/global/staff/stats/all/' + user_id  );
}



getTracesGlobalUserAll(user_id){
    // /api/trace/global/user/stats/all/{user_id}
    return this.http.get(this.$api_get_url + '/api/trace/global/user/stats/all/' + user_id  );
}


getTracesGlobalBrandStatusAll(status, brand_id){
    // /api/trace/global/stats/brand/{status}/{brand_id}
    return this.http.get(this.$api_get_url + '/api/trace/global/stats/brand/' + status + '/' + brand_id  );
}

getTracesGlobalBrandAllLive(brand_id){
    // /api/trace/global/stats/brand/live/all/{brand_id}
    return this.http.get(this.$api_get_url + '/api/trace/global/stats/brand/live/all/' + brand_id);
}

getTracesGlobalBrandAll(brand_id){
    // /api/trace/global/brand/stats/all/{brand_id}
    return this.http.get(this.$api_get_url + '/api/trace/global/brand/stats/all/' + brand_id  );
}


getBrandsAll() {
    // /api/brands/all/get
       return this.http.get(this.$api_get_url + '/api/brands/all/get');
   
   }

   getTraceNotes(trace_id) {
    // /api/trace/notes/any/{trace_id}
       return this.http.get(this.$api_get_url + '/api/trace/notes/any/' + trace_id);

   }


   createTraceNote(model){
       // /api/trace/note/create/{trace_id}
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/trace/note/create/' + model.trace_id, body, httpOptions);
}


// Remove all from assigned trace
deleteTraceNote(note_id) {
    // /api/trace/note/delete/{note_id}
    return this.http.delete(this.$api_get_url + '/api/trace/note/delete/' + note_id );
}


deleteTraceFile(filename) {
    // /api/trace/note/delete/{note_id}
    return this.http.delete(this.$api_get_url + '/api/trace/note/delete/' + filename );
}




getTraceCandidateNotes(trace_candidate_id) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/trace/candidate/notes/any/' + trace_candidate_id);

   }


   createTraceCandidateNote(model){
    // /api/trace/candidate/note/create/{trace_candidate_id}
 let body = JSON.stringify(model);
return this.http.post( this.$api_get_url + '/api/trace/candidate/note/create/' + model.trace_candidate_id, body, httpOptions);
}



// Remove all from assigned trace
deleteNote(note_id) {
    // /api/trace/note/delete/{note_id}
    return this.http.delete(this.$api_get_url + '/api/trace/note/delete/' + note_id );
}




// BOF Sharmans
deleteInvoice(invoice_id) {
    // /api/trace/note/delete/{note_id}
    return this.http.delete(this.$api_get_url + '/api/job/subject/invoice/delete/' + invoice_id );
}



// BOF Sharmans
deleteWorkOrder(work_order_id) {
    // /api/trace/note/delete/{note_id}
    return this.http.delete(this.$api_get_url + '/api/job/subject/work_order/delete/' + work_order_id );
}





getJobTypesTree() {
    return this.http.get(this.$api_get_url + '/api/job/types/tree');
}


getJobTypes() {
    return this.http.get(this.$api_get_url + '/api/job/types');
}

getJobServiceTimeframeCountTypes() {
    return this.http.get(this.$api_get_url + '/api/job/service_timeframe/count_types');
}

getJobServiceTimeframeTimeTypes() {
    return this.http.get(this.$api_get_url + '/api/job/service_timeframe/time_types');
}


getJobServiceTimeframeTimeWhen() {
    return this.http.get(this.$api_get_url + '/api/job/service_timeframe/time_when');
}

getJobServiceTimeframeDateTypes() {
    return this.http.get(this.$api_get_url + '/api/job/service_timeframe/date_types');
}

getJobTable() {
    return this.http.get(this.$api_get_url + '/api/job/table/all');
}

// for dependant drop down for locations by job type id
getJobTypeLocations(job_type_id) {
    return this.http.get(this.$api_get_url + '/api/job/type/locations/' + job_type_id);
}


getJobTypeLocationsTraditional(job_type_id) {
    return this.http.get(this.$api_get_url + '/api/job/type/locations/traditional/' + job_type_id);
}

 // get job types courts from location id drop down
getJobTypeCourts(job_type_location_id) {
    return this.http.get(this.$api_get_url + '/api/job/type/courts/' + job_type_location_id);
}

 // get job_type_document_types from court_type id
 getJobTypeDocumentTypes(job_type_court_id) {
     return this.http.get(this.$api_get_url + '/api/job/type/documentTypes/' + job_type_court_id);
 }


  // get job_type_document_types from court_type id
  getJobTypeDocumentType(job_type_document_type_id) {
    return this.http.get(this.$api_get_url + '/api/job/type/documentType/get/' + job_type_document_type_id);
}



  // get job_type_affidavit_types from job_type_document_type id
  getJobTypeAffidavitTypes(job_type_document_type_id)
  {
      return this.http.get(this.$api_get_url + '/api/job/type/affidavitTypes/' + job_type_document_type_id);
  }

    // get job_type_affidavit_types from job_type_document_type id
    getJobTypeAffidavitTypesGrid(job_type_document_type_id)
    {
        return this.http.get(this.$api_get_url + '/api/job/type/affidavitTypes/grid/' + job_type_document_type_id);
    }

// sharman Clients
createClient(model)
{
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/client/create', body, httpOptions);
}
getClients() {
    return this.http.get(this.$api_get_url + '/api/clients');
}

// -- Client Contacts
getClientContactsSharmans(client_id) {
    return this.http.get(this.$api_get_url + '/api/client_contacts_sharmans/get/' +  client_id );
}

// -- Client Contact
getClientContactSharmans(id) {
    return this.http.get(this.$api_get_url + '/api/client_contact_sharmans/get/' +  id );
}


createJob(model)
{
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_url + '/api/job/create', body, httpOptions);
    /// Maybe get the vars here and then rediect the page from the actual component.
}


getJobID(job_id) {
    return this.http.get(this.$api_get_url + '/api/job/get/' +  job_id );
}

getPositions()
{
    return this.http.get(this.$api_get_url + '/api/get/positions');
}


updateJobStep2(model) {
    let body = JSON.stringify(model);
   // console.log(model);
    return this.http.put(this.$api_get_url + '/api/job/update/step2/' + model.job_id, body, httpOptions);
}


updateJobAll(model) {
    let body = JSON.stringify(model);
   // console.log(model);
    return this.http.put(this.$api_get_url + '/api/job/update/all/' + model.job_id, body, httpOptions);
}


createJobSubjectsMuliple(model)
{
    let body = JSON.stringify(model);
    // tslint:disable-next-line:max-line-length
    return this.http.put(this.$api_get_url + '/api/job/subjects/create/multiple/' + model.job_id + '/' + model.number_subjects , body, httpOptions);
    /// Maybe get the vars here and then rediect the page from the actual component.
}


createJobSubjectsMulipleJobButton(model)
{
    let body = JSON.stringify(model);
    // tslint:disable-next-line:max-line-length
    return this.http.put(this.$api_get_url + '/api/job/subjects/create/multiple/job-button/' + model.job_id + '/' + model.number_subjects , body, httpOptions);
    /// Maybe get the vars here and then rediect the page from the actual component.
}


newSubjectReference(model)
{
    let body = JSON.stringify(model);
    // tslint:disable-next-line:max-line-length
    return this.http.put(this.$api_get_url + '/api/job/subjects/create/new/reference/' + model.subject_id, body, httpOptions);
    /// Maybe get the vars here and then rediect the page from the actual component.
}

newSubjectJobType(model)
{
    let body = JSON.stringify(model);
    // tslint:disable-next-line:max-line-length
    return this.http.put(this.$api_get_url + '/api/job/subjects/create/new/jobtype/' + model.subject_id, body, httpOptions);
    /// Maybe get the vars here and then rediect the page from the actual component.
}


newSubjectJobTypeAnySubject(model)
{
    let body = JSON.stringify(model);
    // tslint:disable-next-line:max-line-length
    return this.http.put(this.$api_get_url + '/api/job/subjects/create/new/jobtype/anysubject/' + model.subject_id, body, httpOptions);
    /// Maybe get the vars here and then rediect the page from the actual component.
}

getSubjectProgress(job_id, file_number) {
    return this.http.get(this.$api_get_url + '/api/job/subjects/progression/' +  job_id + '/' + file_number );
}


getJobSubjects(job_id) {
    return this.http.get(this.$api_get_url + '/api/job/subjects/' +  job_id );
}

getJobSubjectsStagesOnly(job_id) {
    return this.http.get(this.$api_get_url + '/api/job/subjects/stages-only/' +  job_id );
}

getJobSubjectsNotInReportList(job_id) {
    return this.http.get(this.$api_get_url + '/api/job/subjects/notinreportlist/' +  job_id );
}

getJobSubject(subject_id) {
    return this.http.get(this.$api_get_url + '/api/job/get/subject/' +  subject_id );
}

getJobSubjectBySubjectNumber(subject_number) {
    return this.http.get(this.$api_get_url + '/api/job/get/subject/by/subject_number/' +  subject_number );
}


getJobSubjectsAll() {
    return this.http.get(this.$api_get_url + '/api/job/all/subjects');
}

getUserTodos(user_id) {
    return this.http.get(this.$api_get_url + '/api/user/todos/' +  user_id );
}

getUserTodo(todo_id, user_id) {
    return this.http.get(this.$api_get_url + '/api/user/todo/' +  todo_id + '/' + user_id );
}

createUserTodo(model){
    // /api/trace/candidate/note/create/{trace_candidate_id}
 let body = JSON.stringify(model);
return this.http.post( this.$api_get_url + '/api/user/todo/create' , body, httpOptions);
}

updateUserTodo(model) {
    let body = JSON.stringify(model);
   console.log(model);
    return this.http.put(this.$api_get_url + '/api/user/todo/update', body, httpOptions);
}

deleteUserTodo(todo_id, user_id) {
    // let body = JSON.stringify(item);
    // console.log(model);
     return this.http.delete(this.$api_get_url + '/api/user/todo/delete/' + todo_id + '/' + user_id, httpOptions);
}


updateJobSubjectDates(model, subject_id) {
    let body = JSON.stringify(model);
   // console.log(model);
    return this.http.put(this.$api_get_url + '/api/job/subject/update/dates/' + subject_id, body, httpOptions);
}

updateJobSubject(model) {
    let body = JSON.stringify(model);
   // console.log(model);
    return this.http.put(this.$api_get_url + '/api/job/subject/update/' + model.subject_id, body, httpOptions);
}

closeSubject(model) {
    let body = JSON.stringify(model);
   // console.log(model);
    return this.http.put(this.$api_get_url + '/api/job/subject/close/' + model.subject_id, body, httpOptions);
}

updateSubjectStatus(model) {
    let body = JSON.stringify(model);
   console.log(model);
    return this.http.put(this.$api_get_url + '/api/job/subject/status/change/window/' + model.subject_id, body, httpOptions);
}

updateJobJobStatus(model) {
    let body = JSON.stringify(model);
   console.log(model);
    return this.http.put(this.$api_get_url + '/api/job/status/change/window/' + model.job_id, body, httpOptions);
}

updateSubjectStatusBulk(result, new_status) {
    let body = JSON.stringify(result);
  // console.log(result);
    return this.http.put(this.$api_get_url + '/api/job/subject/status/change/bulk/' + result.subject_id+ '/' + new_status, body, httpOptions);
}

updateSubjectStatusBulkBasic(result, new_status) {
    let body = JSON.stringify(result);
  // console.log(result);
    return this.http.put(this.$api_get_url + '/api/job/subject/status/change/bulk/basic/' + result.subject_id+ '/' + new_status, body, httpOptions);
}


updateSubjectStatusOnlyBasic(result, new_status) {
    let body = JSON.stringify(result);
  // console.log(result);
    return this.http.put(this.$api_get_url + '/api/job/subject/status/change/only/basic/' + result.subject_id+ '/' + new_status, body, httpOptions);
}

// function to work out logic of either subject or jon statis to be changed via the automation
updateJobAndSubjectStatus(result, new_status) {
    let body = JSON.stringify(result);
 
  // console.log(result);
    return this.http.put(this.$api_get_url + '/api/job/subject/status/update/' + result.subject_id+ '/' + result.job_id, body, httpOptions);
}

clientJobSubmission(job_id) {
   // let body = JSON.stringify(model);
    return this.http.put(this.$api_get_url + '/api/client/job/submission/' + job_id, httpOptions);
};

adminJobSubmission(job_id) {
    // let body = JSON.stringify(model);
     return this.http.put(this.$api_get_url + '/api/admin/job/submission/' + job_id, httpOptions);
 };

getJobsAll() {
    return this.http.get(this.$api_get_url + '/api/jobs/all' );
}

getSubjectsAll() {
    return this.http.get(this.$api_get_url + '/api/subjects/all' );
}

getSubjectsNotClosed(job_id, file_number) {
    return this.http.get(this.$api_get_url + '/api/get/subject/reference/count/notclosed/' + job_id + '/' + file_number, );
}

updateAllSubjectContacts(model) {
    let body = JSON.stringify(model);
     return this.http.put(this.$api_get_url + '/api/job/subject/contacts/update/' + model.subject_id + '/' + model.job_id , body,  httpOptions);
 };



getJobType(job_type_id)
{
   
    return this.http.get(this.$api_get_url + '/api/job/type/' + job_type_id);

   //try to return one value not the entire json
   // let myObj = JSON.parse(this.$api_get_url + '/api/job/type/' + job_type_id);
   // return myObj.job_type_name;
}


getClientMappingAll()
{

    return this.http.get(this.$api_get_url + '/api/client/mappings/all');

   //try to return one value not the entire json
   // let myObj = JSON.parse(this.$api_get_url + '/api/job/type/' + job_type_id);
   // return myObj.job_type_name;
}


getClientMappingID(client_id)
{

   return this.http.get(this.$api_get_url + '/api/client/mappings/' + client_id);
   


   
   //try to return one value not the entire json
   // let myObj = JSON.parse(this.$api_get_url + '/api/client/mappings/' + client_id);
  // return myObj.name;
}



getClientMappingNameOnly(client_id)
{
 return this.http.get(this.$api_get_url + '/api/client/mappings_name_only/' + client_id);
   //try to return one value not the entire json
   // let myObj = JSON.parse(this.$api_get_url + '/api/job/type/' + job_type_id);
   // return myObj.job_type_name;
}

getClientContactID(id)
{
    return this.http.get(this.$api_get_url + '/api/client/contact/mappings/' + id);
}


getJobSubjectTypes()
{
    return this.http.get(this.$api_get_url + '/api/job/subject/types');
}

getJobPlaintiffTypes()
{
    return this.http.get(this.$api_get_url + '/api/job/plaintiff/types');
}


getAllJobPlaintiffs()
{
    return this.http.get(this.$api_get_url + '/api/job/plaintiffs');
}


getAllJobSubjectDocumentss()
{
    return this.http.get(this.$api_get_url + '/api/job/subject/documents');
}



getJobReportSubjects(job_id)
{
    return this.http.get(this.$api_get_url + '/api/job/report/subjects/' + job_id);
}


createJobStatus(model)
{
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_url + '/api/job/job/status/create', body, httpOptions);
    /// Maybe get the vars here and then rediect the page from the actual component.
}



getClient(client_id)
{
    return this.http.get(this.$api_get_url + '/api/client/' + client_id);
}




updateClient(model) {
    let body = JSON.stringify(model);
   // console.log(model);
    return this.http.put(this.$api_get_url + '/api/client/update/' + model.client_id, body, httpOptions);
}




createBrandClientContactSharmans(model){
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/client_contact_sharmans/create/' + model.client_id, body, httpOptions);
}

updateBrandClientContactSharmans(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/client_contact_sharmans/update/' + model.id, body, httpOptions);
}


getJobTypeAllLocations()
{
    return this.http.get(this.$api_get_url + '/api/job/type/all/locations');
}

getJobTypeAllCourts()
{
    return this.http.get(this.$api_get_url + '/api/job/type/all/courts');
}


getJobTypeAllDocumentTypes()
{
    return this.http.get(this.$api_get_url + '/api/job/type/all/document/types');
}

getJobTypeAllAffidavitTypes()
{
    return this.http.get(this.$api_get_url + '/api/job/type/all/affidavit/types');
}


getJobTypeAllAffidavitType(job_type_affidavit_type_id)
{
    return this.http.get(this.$api_get_url + '/api/job/type/all/affidavit/type/' + job_type_affidavit_type_id);
}

createJobCourt(model){
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/job/court/create', body, httpOptions);
}

getJobTypeCourt(job_type_court_id)
{
    return this.http.get(this.$api_get_url + '/api/job/type/courts/get/' + job_type_court_id);
}

updateJobCourt(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/job/court/update/' + model.job_type_court_id, body, httpOptions);
}

createJobTypeDocuemnt(model) {
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/job/document/type/create', body, httpOptions);
}


getJobTypeDocument(job_type_document_type_id)
{
    return this.http.get(this.$api_get_url + '/api/job/type/document/get/' + job_type_document_type_id);
}

updateJobTypeDocument(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/job/document/type/update/' + model.job_type_document_type_id, body, httpOptions);
}


createJobTypeAffidavit(model) {
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/job/affidavit/type/create', body, httpOptions);
}

createJobServiceRule(model) {
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/job/service_rule/create', body, httpOptions);
}

createJobServiceTimeframe(model) {
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/job/service_timeframe/create', body, httpOptions);
}

getJobTypeAffidavit(job_type_affidavit_type_id)
{
    return this.http.get(this.$api_get_url + '/api/job/type/affidavit/get/' + job_type_affidavit_type_id);
}


updateJobTypeAffidavit(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/job/affidavit/type/update/' + model.job_type_affidavit_type_id, body, httpOptions);
}


createJobLocation(model) {
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/job/location/create', body, httpOptions);
}

getJobTypeLocation(job_type_location_id)
{
    return this.http.get(this.$api_get_url + '/api/job/type/location/get/' + job_type_location_id);
}

updateJobLocation(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/job/location/update/' + model.job_type_location_id, body, httpOptions);
}

createJobType(model) {
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/job/type/create', body, httpOptions);
}

createSystemLogType(model) {
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/system_log_type/create', body, httpOptions);
}


createSystemLogTypeDataSectorType(model) {
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/system_log_type_data_sector_type/create', body, httpOptions);
}

createSystemLogTypeDataSectorCondition(model) {
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/system_log_type_data_sector_condition/create', body, httpOptions);
}



createSystemLogTypeDataSector(model) {
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/system_log_type_data_sector/create', body, httpOptions);
}


createSubjectSeviceOutcomeTemplate(model) {
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/subject_service_outcome_template/create', body, httpOptions);
}

createSubjectUrgentOutcomeTemplate(model) {
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/subject_urgent_outcome_template/create', body, httpOptions);
}


updateJobType(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/job/type/update/' + model.job_type_id, body, httpOptions);
}

updateJobStatus(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/job/status/update/' + model.job_status_id, body, httpOptions);
}


getJobStatusNames()
{
    return this.http.get(this.$api_get_url + '/api/job/status/name');
}


getJobStatusDetails(job_status_name)
{
    return this.http.get(this.$api_get_url + '/api/job/status/details/' + job_status_name);
}

getJobStatusDetailsByID(job_status_id)
{
    return this.http.get(this.$api_get_url + '/api/job/status/details/ByID/' + job_status_id);
}


getJobSubjectType(job_subject_type_id)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/type/' +  + job_subject_type_id );
}

getJobPlaintiffType(job_plaintiff_type_id)
{
    return this.http.get(this.$api_get_url + '/api/job/plaintiff/type/' + job_plaintiff_type_id);
}


createSubjectNote(model){
    // /api/trace/candidate/note/create/{trace_candidate_id}
 let body = JSON.stringify(model);
return this.http.post( this.$api_get_url + '/api/job/subject/note/create/' + model.subject_id, body, httpOptions);
}

createSubjectNoteWithVars(model){
    // /api/trace/candidate/note/create/{trace_candidate_id}
 let body = JSON.stringify(model);
return this.http.post( this.$api_get_url + '/api/job/subject/note_with_vars/create/' + model.subject_id, body, httpOptions);
}


createSubjectNoteBasic(model){
    // /api/trace/candidate/note/create/{trace_candidate_id}
 let body = JSON.stringify(model);
return this.http.post( this.$api_get_url + '/api/job/subject/note/create/basic/' + model.subject_id, body, httpOptions);
}


getSubjectNotes(subject_id) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/job/subject/notes/any/' + subject_id);

   }

getSubjectNote(note_id) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/job/subject/note/' + note_id);

   }

   getJobNotes(job_id) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/job/notes/any/' + job_id);

   }

   getBrandNotes(brand_id) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/brand/notes/any/' + brand_id);

   }

    // put instead of get so that model can be sent for quiery.
   getSubjectNotesGrid(model) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
    let body = JSON.stringify(model);
       return this.http.put(this.$api_get_url + '/api/job/subject/notes/any/grid/' + model.subject_id, body, httpOptions);

   };

   getSubjectNotesProgression(job_id, file_number) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/job/subject/notes/progression/' + job_id + '/' + file_number);

   }


  
   getSubjectNotesProgressionTable(job_id, file_number, model) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
    let body = JSON.stringify(model);
       return this.http.put(this.$api_get_url + '/api/job/subject/notes/progression/tabledata/' + job_id + '/' + file_number,
        body, httpOptions);

   }

   getSubjectNotesProgressionTableLimit5(job_id, file_number, model) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
    let body = JSON.stringify(model);
       return this.http.put(this.$api_get_url + '/api/job/subject/notes/progression/tabledata/limit5/' + job_id + '/' + file_number,
        body, httpOptions);

   }
  
//    getSubjectNotesProgressionTable(job_id, file_number) {
//     // /api/trace/candidate/notes/any/{trace_candidate_id}
//        return this.http.get(this.$api_get_url + '/api/job/subject/notes/progression/tabledata/' + job_id + '/' + file_number);

//    }

   getJobSubjectsUrgentTable() {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/job/table/all/urgent/tabledata');

   }


      getJobSubjectsUrgentTimeframeTable() {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/job/table/all/urgent-timeframe/tabledata');

   }


   getJobSubjectsUrgentTableClient(brand_id) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/job/table/all/urgent/tabledata/client/' + brand_id);

   }

      getJobSubjectsUrgentTimeframeTableClient(brand_id) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/job/table/all/urgent-timeframe/tabledata/client/' + brand_id);

   }


      getJobSubjectsUrgentTimeframeTableAgent(brand_id, assigned_agent) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/job/table/all/urgent-timeframe/tabledata/agent/' + brand_id + '/' + assigned_agent);

   }


   getJobSubjectsUrgentTableSearch(model) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
    let body = JSON.stringify(model);
       return this.http.put(this.$api_get_url + '/api/job/table/all/urgent/tabledata/search', body, httpOptions);

   }


   getJobSubjectsUrgentTableSearchReporting(model) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
    let body = JSON.stringify(model);
       return this.http.put(this.$api_get_url + '/api/job/table/all/urgent/tabledata/search/reporting', body, httpOptions);

   }

   getReportContactsSearch(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/report/contacts/search', body, httpOptions);
   }

   getReportBrandsSearch(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/report/brands/search', body, httpOptions);
   }

   getReportSubjectsUrgentSearch(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/report/subjects_urgent/search', body, httpOptions);
   }


      getReportSubjectsUrgentTimeframeSearch(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/report/subjects_urgent_timeframe/search', body, httpOptions);
   }


      getReportSubjectsUrgentTimeframeSendCSVExport(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/report/subjects_urgent_timeframe/send_csv_report', body, httpOptions);
   }



   getReportSubjectsUrgentSearchClient(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/report/subjects_urgent/search/client', body, httpOptions);
   }


   getReportSubjectsUrgentTiemrameSearchClient(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/report/subjects_urgent_timeframe/search/client', body, httpOptions);
   }


// new agent subjects urgent. Timeframes Only.
 getReportSubjectsUrgentSearchAgetn(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/report/subjects_urgent/search/agent', body, httpOptions);
   }



   getReportUsersSearch(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/report/users/search', body, httpOptions);
   }

   getPaymentsSearch(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/paymentsSearch', body, httpOptions);
   }


   getPaymentsSearch2(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/paymentsSearch2', body, httpOptions);
   }

   getInvoicesSearch(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/invoicesSearch', body, httpOptions);
   }


   getWorkOrdersSearch(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/work_ordersSearch', body, httpOptions);
   }


   getJobsTableData() {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/job/table/all/tabledata');
   };

   
   getBrandJobsTableData(brand_id) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/job/table/all/tabledata/brand/jobs/' + brand_id);
   };

   getBrandJobsTableDataGrid(brand_id, job_status_code, assigned_agent) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       // tslint:disable-next-line:max-line-length
       return this.http.get(this.$api_get_url + '/api/job/table/all/tabledata/brand/jobs/grid/' + brand_id + '/' + job_status_code + '/' + assigned_agent );
   };


   getBrandJobsTableDataGrid_Sorting(brand_id, job_status_code, assigned_agent, search_model) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
           // tslint:disable-next-line:max-line-length
    let body = JSON.stringify(search_model);

       return this.http.put(this.$api_get_url + '/api/job/table/all/tabledata/brand/sorting/jobs/grid/' + brand_id + '/' + job_status_code + '/' + assigned_agent,  body, httpOptions );
   };



   getBrandJobsTableDataGrid_TreePost(brand_id, job_status_code, assigned_agent, search_model) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
           // tslint:disable-next-line:max-line-length
    let body = JSON.stringify(search_model);

       return this.http.put(this.$api_get_url + '/api/job/table/all/tabledata/brand/jobs/grid/' + brand_id + '/' + job_status_code + '/' + assigned_agent,  body, httpOptions );
   };


   getJobsTableDataClosed(){
    return this.http.get(this.$api_get_url + '/api/job/table/all/tabledata/closed');
   }

  getJobsTableDataSubjects(job_id){
    return this.http.get(this.$api_get_url + '/api/job/table/all/tabledata/job/subjects/' + job_id);
   } 


  getJobsTableDataSubjectsOnly(job_id){
    return this.http.get(this.$api_get_url + '/api/job/table/all/tabledata/job/subjects-only/' + job_id);
   } 


   getAssignedAgentsJobsSubjectsGrid(job_id, brand_id, job_status_code, assigned_agent){
    return this.http.get(this.$api_get_url + '/api/job/table/assigned_agent/job/subjects/' + job_id + '/'
     + brand_id + '/' + job_status_code + '/' + assigned_agent);
   }

   getUsersTableData() {
       return this.http.get(this.$api_get_url + '/api/user/table/all');
   };


   getUserGridData(model) {
    let body = JSON.stringify(model);
    return this.http.put(this.$api_get_url + '/api/user/grid',  body, httpOptions);
};


   

// Remove all from assigned trace
deleteSubjectNote(note_id) {
    // /api/trace/note/delete/{note_id}
    return this.http.delete(this.$api_get_url + '/api/job/subject/note/delete/' + note_id );
}


getSubjectBilling(subject_id) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/job/subject/billing/any/' + subject_id);

   }
   createSubjectBilling(model){
    // /api/trace/candidate/note/create/{trace_candidate_id}
 let body = JSON.stringify(model);
return this.http.post( this.$api_get_url + '/api/job/subject/billing/create/' + model.subject_id, body, httpOptions);
}

updateSubjectBilling(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/job/subject/billing/update/' + model.subject_billing_id, body, httpOptions);
}

// assinged or allocated traces
getJobAgentsAssigned(job_id) {
    return this.http.get(this.$api_get_url + '/api/job/agents/assigned/'  + job_id );
}


// assinged or allocated traces
getSubjectAgentsAssigned(subject_id) {
    return this.http.get(this.$api_get_url + '/api/job/subject/agents/all/assigned/'  + subject_id );
}

getSubjectAgentBrandsAssigned(subject_id) {
    // return this.http.get<[]>(this.$api_get_url + '/api/job/subject/agents/brands/assigned/'  + subject_id );
    return this.http.get(this.$api_get_url + '/api/job/subject/agents/brands/assigned/'  + subject_id );
}

getSubjectAgentBrandsAssigned$(subject_id) {
    // return this.http.get<[]>(this.$api_get_url + '/api/job/subject/agents/brands/assigned/'  + subject_id );
    return this.http.get<[]>(this.$api_get_url + '/api/job/subject/agents/brands/assigned/'  + subject_id );
}

getSubjectAgentBrandsAssigned_bySubjectNumber(subject_number) {
    return this.http.get(this.$api_get_url + '/api/job/subject/agents/brands/assigned/bySubjectNumber/'  + subject_number );
}




getSubjectAgentsAssignedAll() {
    return this.http.get(this.$api_get_url + '/api/job/subjects/agents/all' );
}


getSubjectBrandAgentsAssignedAll() {
    return this.http.get(this.$api_get_url + '/api/job/subjects/brand/agents/all' );
}

getJobAgentsAllAssigned() {
    return this.http.get(this.$api_get_url + '/api/job/agents/all/assigned/' );
}



// Insert a Single Assigned User Drop Down
createJobAssigedAgent(item, job_id, user_id) {
    let body = JSON.stringify(item);
    return this.http.post( this.$api_get_url + '/api/job/agent/assign/create/' + job_id, body, httpOptions);

}


// Insert a Single Assigned User Drop Down for Subject and Agent
createSubjectAssigedAgent(item, job_id, subject_id,  brand_id, subject_number) {
    let body = JSON.stringify(item);
    return this.http.post( this.$api_get_url + '/api/job/subject/agent/assign/create/' + subject_id + '/' + job_id + '/' + subject_number, body, httpOptions);

}



// Remove a single when checked (as a put)
deleteJobAgentAssigned(item, job_id, user_id) {
    let body = JSON.stringify(item);
    // console.log(model);
     return this.http.put(this.$api_get_url + '/api/job/agent/assign/delete/' + job_id + '/' + user_id, body, httpOptions);
}


// Remove a single when checked (as a put)
deleteSubjectAgentAssigned(item, subject_id, brand_id) {
    let body = JSON.stringify(item);
    // console.log(model);
     return this.http.put(this.$api_get_url + '/api/job/subject/agent/assign/delete/' + subject_id + '/' + brand_id, body, httpOptions);
}


// Remove all from assigned trace
deleteJobAgentAssignedAll(job_id) {
    return this.http.delete(this.$api_get_url + '/api/job/agent/assign/delete/all/' + job_id );
}

// Remove all=
deleteSubjectAgentAssignedAll(item, subject_id) {
    return this.http.delete(this.$api_get_url + '/api/job/subject/agent/assign/delete/all/' + subject_id );
}



createSubjectAttendence(model){
    // /api/trace/candidate/note/create/{trace_candidate_id}
 let body = JSON.stringify(model);
return this.http.post( this.$api_get_url + '/api/job/subject/attendence/create/' + model.subject_id, body, httpOptions);
}


getSubjectAttendence(subject_id) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/job/subject/attendence/any/' + subject_id);

   }


   // Remove all from assigned trace
deleteSubjectAttendence(attendence_id) {
    // /api/trace/note/delete/{note_id}
    return this.http.delete(this.$api_get_url + '/api/job/subject/attendence/delete/' + attendence_id );
}


getSubjectAttemptTypes()
{
    return this.http.get(this.$api_get_url + '/api/job/subject/attempt_types');
}

getPropertyTypes()
{
    return this.http.get(this.$api_get_url + '/api/property/types');
}

getPropertyType(property_type_id)
{
    return this.http.get(this.$api_get_url + '/api/property/type/' + property_type_id);
}



getSubjectAttemptType(subject_attempt_type_id)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/attempt_type/' + subject_attempt_type_id);
}

getServiceOutcomes()
{
    return this.http.get(this.$api_get_url + '/api/job/subject/service_outcomes');
}

getServiceOutcomesAccessLevel(access_level)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/service_outcomes/access_level/' + access_level);
}


getServiceMethods()
{
    return this.http.get(this.$api_get_url + '/api/job/subject/service_methods');
}

// active = Y
getServiceMethodsMenu()
{
    return this.http.get(this.$api_get_url + '/api/job/subject/service_methods/menu');
}


getSubjectRelationships()
{
    return this.http.get(this.$api_get_url + '/api/job/subject/relationships');
}

getExactServiceMethods()
{
    return this.http.get(this.$api_get_url + '/api/job/subject/exact_service_methods');
}

SubjectLocationStatuss()
{
    return this.http.get(this.$api_get_url + '/api/job/subject/location_statuss');
}

getSubjectLocationStatus(subject_location_status_id)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/attendance/location_status/' + subject_location_status_id);
}



SubjectLocationStatussFound()
{
    return this.http.get(this.$api_get_url + '/api/job/subject/location_statuss_found');
}

getSubjectLocationStatusFound(subject_location_status_found_id)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/attendance/location_status_found/' + subject_location_status_found_id);
}




createSubjectService(model){
    // /api/trace/candidate/note/create/{trace_candidate_id}
 let body = JSON.stringify(model);
return this.http.post( this.$api_get_url + '/api/job/subject/service/create/' + model.subject_id, body, httpOptions);
}

editSubjectService(model){
    // /api/trace/candidate/note/create/{trace_candidate_id}
 let body = JSON.stringify(model);
return this.http.put( this.$api_get_url + '/api/job/subject/service/edit/' + model.subject_service_id, body, httpOptions);
}

getSubjectServices(subject_id) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/job/subject/services/any/' + subject_id);

   }

   getSubjectServicesByJobId(job_id) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/job/services/any/' + job_id);

   }



   getSubjectServicesOnly(subject_id) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/job/subject/services_only/any/' + subject_id);

   }


   getBrandServices(brand_id) {
    // /api/trace/candidate/notes/any/{trace_candidate_id}
       return this.http.get(this.$api_get_url + '/api/brand/subject/services/any/' + brand_id);

   }   

 
   // Original Query - with all extra queries was way too slow.
   getSubjectService(subject_service_id) {
       return this.http.get(this.$api_get_url + '/api/job/subject/service/' + subject_service_id);

   }

    
   // Original Query - with all extra queries was way too slow.
   getSubjectServiceConverted(subject_service_id) {
    return this.http.get(this.$api_get_url + '/api/job/subject/service/view/' + subject_service_id);

}
  
  /*
   getSubjectService(subject_service_id) {
    return this.http.get(this.$api_get_url + '/api/job/subject/service/' + subject_service_id);

}
 */

getSubjectServiceAll(subject_id) {
    return this.http.get(this.$api_get_url + '/api/job/subject/service/allquieries/' + subject_id);

}

   getServiceMethod(subject_service_method_id)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/service_method/' + subject_service_method_id );
}


getSubjectRelationship(subject_relationship_id)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/relationship/' + subject_relationship_id);
}


getExactServiceMethod(exact_service_method_id)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/exact_service_method/' + exact_service_method_id);
}


getSubjectServiceOutcome(subject_service_outcome_id)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/exact_service_outcome/' + subject_service_outcome_id);
}

deleteSubjectService(subject_service_id) {
    // /api/trace/note/delete/{note_id}
    return this.http.delete(this.$api_get_url + '/api/job/subject/service/delete/' + subject_service_id );
}

deleteSubjectsServices(subject_id) {
    // /api/trace/note/delete/{note_id}
    return this.http.delete(this.$api_get_url + '/api/job/subjects/services/delete/' + subject_id );
}


deleteSubjectLogs(subject_service_id) {
    // /api/trace/note/delete/{note_id}
    return this.http.delete(this.$api_get_url + '/api/subject/logs/delete/' + subject_service_id );
}

deleteUser(user_id) {
    // /api/trace/note/delete/{note_id}
    return this.http.delete(this.$api_get_url + '/api/user/delete/' + user_id );
}

deleteJobLogs(job_id) {
    // /api/trace/note/delete/{note_id}
    return this.http.delete(this.$api_get_url + '/api/job/logs/delete/' + job_id );
}

deleteSubjectCommunicationHistory(subject_id) {
    // /api/trace/note/delete/{note_id}
    return this.http.delete(this.$api_get_url + '/api/subject/communication_history/delete/' + subject_id );
}

getBrandBrandTypes()
{
    return this.http.get(this.$api_get_url + '/api/brand/brand_types');
}

getBrandBrandTypesNoOwner()
{
    return this.http.get(this.$api_get_url + '/api/brand/brand_types/no-owner');
}

getBrandBrandType(brand_type_id)
{
    return this.http.get(this.$api_get_url + '/api/brand/brand_type/' + brand_type_id);
}

getBrandAgents(){
    return this.http.get(this.$api_get_url + '/api/brands/agents');
}
// 

// MYOB API Oauth Testing
getMyobCode() {
    // tslint:disable-next-line:max-line-length
//encoded - https://www.urlencoder.org/
// http%3A%2F%2Flocalhost%3A4200%2F%23%2Fadmin%2Fmyob-login

    return this.http.get('https://secure.myob.com/oauth2/account/authorize?client_id=2v2hs2xtbj86nubnxxnszpdx&redirect_uri=http%3A%2F%2Flocalhost%3A4200%2F%23%2Fadmin%2Fmyob-login&response_type=code&scope=CompanyFile', httpOptions2);
}





/*
*
* :: MYOB NodeJs Connections:  port: 1050
* :: seperate node application needs to be running on localhost: or Server:
*
*/

getMyobCustomers(){
   return this.http.get(this.$api_get_sopNode + '/api/myob/company/customers');
 // Gives cors errors
 // return this.http.get('https://sop.nickbowen.com.au/api/myob/company/customers');
} // end class

getMyobSuppliers(){
    return this.http.get(this.$api_get_sopNode + '/api/myob/company/suppliers');
  // Gives cors errors
  // return this.http.get('https://sop.nickbowen.com.au/api/myob/company/customers');
 } // end class
 

createMyobCustomer(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_sopNode + '/api/myob/company/myob_customer/create', body, httpOptions);
 } // end class

 createMyobSupplier(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_sopNode + '/api/myob/company/myob_supplier/create', body, httpOptions);
 } // end class
 

 updateMyobCustomer(model) {
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_sopNode + '/api/myob/company/myob_customer/update/' + model.UID, body, httpOptions);
 } // end class
  

 updateMyobSupplier(model) {
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_sopNode + '/api/myob/company/myob_supplier/update/' + model.UID, body, httpOptions);
 } // end class
  

 deleteMyobCustomer(model) {
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_sopNode + '/api/myob/company/myob_customer/delete/' + model.myob_id, body, httpOptions);
 } // end class

 deleteMyobSupplier(model) {
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_sopNode + '/api/myob/company/myob_supplier/delete/' + model.myob_id, body, httpOptions);
 } // end class


getMyobCustomersMapped() {
    return this.http.get(this.$api_get_sopNode + '/api/myob/company/customers')
    .pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError( 'Something went wrong!' );
        })
     );
 } // end class


 getMyobSuppliersMapped() {
    return this.http.get(this.$api_get_sopNode + '/api/myob/company/suppliers')
    .pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError( 'Something went wrong!' );
        })
     );
 } // end class


getMyobCustomer(UID){
    return this.http.get(this.$api_get_sopNode + '/api/myob/company/customer/' + UID);
 } // end class
getMyobSupplier(UID){
    return this.http.get(this.$api_get_sopNode + '/api/myob/company/supplier/' + UID);
} // end class


 // Map http client to interface // and return as observable.
 
 getMyobCustomerMapped(UID, model?){
    return this.http.get(this.$api_get_sopNode + '/api/myob/company/customer/' + UID)
    .pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
         
            let err = error;
            // Need to set some error varibles
            this.error_message = err.error.error_message;
            this.error_message_standard = err.error.error_message_standard;
            this.error_name = err.error.error_name;
            this.full_response_data = err.error.full_response_data;
            this.data_sent = err.error.data_sent;
            this.data_sent_id = err.error.data_sent_invoice_id;
         
           
         
            this.response_from_node = JSON.stringify(err)
            this.response_from_node_raw = err;
            this.sendResponse.emit(this.response_from_node);
            console.log(' getCustomerMapopped(UID, model): ' + this.response_from_node)
           //  this.test_message = this.response_from_node; // could be as simple as this?
            return(this.response_from_node = JSON.stringify(err)); // do this so other componets get
         
         
            return throwError( 'Something went wrong!' );
        })
     )
 } 


 getMyobSupplierMapped(UID, model?){
    return this.http.get(this.$api_get_sopNode + '/api/myob/company/supplier/' + UID)
    .pipe(
        map((data: any) => {
          return data;
        }), catchError( 
            (error) => {
        //   return throwError( 'Something went wrong!');
 let err = error;
   // Need to set some error varibles
   this.error_message = err.error.error_message;
   this.error_message_standard = err.error.error_message_standard;
   this.error_name = err.error.error_name;
   this.full_response_data = err.error.full_response_data;
   this.data_sent = err.error.data_sent;
   this.data_sent_id = err.error.data_sent_invoice_id;

  

   this.response_from_node = JSON.stringify(err)
   this.response_from_node_raw = err;
   this.sendResponse.emit(this.response_from_node);
   console.log(' getWorkOrderItmes(work_order_id, model): ' + this.response_from_node)
  //  this.test_message = this.response_from_node; // could be as simple as this?
   return(this.response_from_node = JSON.stringify(err)); // do this so other componets get



           
        })
     )
 } 
 

 getMyobInvoiceMapped(UID, model?){
    return this.http.get(this.$api_get_sopNode + '/api/myob/company/myob_service_invoice/' + UID)
    .pipe(
        map((data: any) => {
          return data;
        }), catchError( error => {
          return throwError( 'Something went wrong!' );
        })
     )
 } 
 

 
 getMyobPurchaseMapped(UID, model?){
    return this.http.get(this.$api_get_sopNode + '/api/myob/company/myob_service_purchase/' + UID)
    .pipe(
        map((data: any) => {
          return data
        }), catchError( error => {
          return throwError( 'Something went wrong!' );
        })
     )
 } 
 


 getMyobPaymentsMapped(UID, model?){
    return this.http.get(this.$api_get_sopNode + '/api/myob/company/myob_service_invoice/payment/' + UID)
    .pipe(
        map((data:any) => {
          return data;
        }), catchError( error => {
          return throwError( 'Something went wrong!' );
        })
     )
 } 
 

 
 getMyobSpendingsMapped(UID, model?){
    return this.http.get(this.$api_get_sopNode + '/api/myob/company/myob_service_work_order/spending/' + UID)
    .pipe(
        map((data: any) => {
          return data;
        }), catchError( 
            (error) => {
        //   return throwError( 'Something went wrong!');
 let err = error;
   // Need to set some error varibles
   this.error_message = err.error.error_message;
   this.error_message_standard = err.error.error_message_standard;
   this.error_name = err.error.error_name;
   this.full_response_data = err.error.full_response_data;
   this.data_sent = err.error.data_sent;
   this.data_sent_id = err.error.data_sent_invoice_id;

  

   this.response_from_node = JSON.stringify(err)
   this.response_from_node_raw = err;
   this.sendResponse.emit(this.response_from_node);
   console.log(' getWorkOrderItmes(work_order_id, model): ' + this.response_from_node)
  //  this.test_message = this.response_from_node; // could be as simple as this?
   return(this.response_from_node = JSON.stringify(err)); // do this so other componets get



           
        })
     )
 } 
 


 createMyobInvoice(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_sopNode + '/api/myob/company/myob_invoice/create', body, httpOptions);
 } // end class
 createMyobWorkOrder(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_sopNode + '/api/myob/company/myob_purchase/create', body, httpOptions);
 } // end class

 createMyobPayment(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_sopNode + '/api/myob/company/myob_payment/create', body, httpOptions);
 } // end class


 createMyobSpending(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_sopNode + '/api/myob/company/myob_spending/create', body, httpOptions);
 } // end class



 updateMyobInvoice(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_sopNode + '/api/myob/company/myob_invoice/update/' + model.UID, body, httpOptions);
 } // end class
  

 
 updateMyobWorkOrder(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_sopNode + '/api/myob/company/myob_work_order/update/' + model.UID, body, httpOptions);
 } // end class
  
 

 getMyobInvoices(){
    return this.http.get(this.$api_get_sopNode + '/api/myob/company/myob_service_invoices');
 } // end class

 getMyobPurchases(){
    return this.http.get(this.$api_get_sopNode + '/api/myob/company/myob_service_purchases');
 } 


 deleteMyobInvoice(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_sopNode + '/api/myob/company/myob_service_invoice/delete/' + model.myob_id, body, httpOptions);
 } // end class

 deleteMyobInvoiceUID(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_sopNode + '/api/myob/company/myob_service_invoice/delete/' + model.UID, body, httpOptions);
 } // end class

 deleteMyobWorkOrder(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_sopNode + '/api/myob/company/myob_service_purchase/delete/' + model.myob_id, body, httpOptions);
 } // end class


 deleteMyobPayment(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_sopNode + '/api/myob/company/myob_service_invoice/payment/delete/' + model.myob_id, body, httpOptions);
 } // end class


 deleteMyobPaymentDirect(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_sopNode + '/api/myob/company/myob_service_invoice/payment/delete/' + model.UID, body, httpOptions);
 } 

 deleteMyobSpendingPayment(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_sopNode + '/api/myob/company/myob_service_work_order/payment/delete/' + model.myob_id, body, httpOptions);
 } // end class


 getMyobInvoice(UID, model?){
    return this.http.get(this.$api_get_sopNode + '/api/myob/company/myob_service_invoice/' + UID);
 } // end class



 getMyobAccountCodesLive(){
    return this.http.get(this.$api_get_sopNode + '/api/myob/company/myob_account_codes');
 } // end class

 getMyobTaxCodesLive(){
    return this.http.get(this.$api_get_sopNode + '/api/myob/company/myob_tax_codes');
 } // end class


// :: Myob Payments

 getMyobCustomerPaymerntsLive(){
    return this.http.get(this.$api_get_sopNode + '/api/myob/company/sale/payments');
 }

 getMyobPurchasePaymerntsLive(){
    return this.http.get(this.$api_get_sopNode + '/api/myob/company/purchase/payments');
 }


getMyobAuthStatus(): Observable<MyobAuthStatus> {
  return this.http.get<MyobAuthStatus>(
    this.$api_get_sopNode + '/api/myob/oauth/granular/status'
  );
}

refreshMyobTokens(): Observable<MyobRefreshResult> {
  return this.http.post<MyobRefreshResult>(
    this.$api_get_sopNode + '/api/myob/oauth/granular/refresh',
    {}
  );
}

myobChecker(): Observable<MyobAuthStatus> {
  return this.getMyobAuthStatus()
    .pipe(
      map(status => {
        const ready =
          status.connected === true &&
          status.granularReady === true &&
          status.authorizationType === 'granular' &&
          status.businessId === environment.myobCustomeID;

        if (!ready) {
          throw new Error('MYOB granular authorisation is not ready.');
        }

        return status;
      })
    );
}

myobCheckerCompanyConnection(): Observable<MyobAuthStatus> {
  return this.myobChecker();
}


// Get Document Types from Json

getDocumentTypes()
{
    return this.http.get(this.$api_get_url + '/documentTypes.json');
}


getSubjectComTypes()
{
    return this.http.get(this.$api_get_url + '/api/job/subject/com_types');
}
getSubjectComType(subject_com_type_id)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/com_type/' + subject_com_type_id);
}


getSystemAutomation(system_automation_id)
{
    return this.http.get(this.$api_get_url + '/api/system_automation/' + system_automation_id);
}

getSystemAutomationActive(system_automation_id)
{
    return this.http.get(this.$api_get_url + '/api/system_automation_active/' + system_automation_id);
}

updateSubjectComType(model){
    const body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/communication/com_types/update/' + model.subject_com_type_id, body, httpOptions);
}

createSubjectComType(model){
   const body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/communication/com_types/create/', body, httpOptions);
}


getSubjectComTypesGrid()
{
    return this.http.get(this.$api_get_url + '/api/job/subject/com_types/grid');
}

getSubjectTemplateDocs(subject_com_type_id)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/template_docs/' + subject_com_type_id);
}

getSubjectTemplateDocsMenu(subject_com_type_id)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/template_docs/menu/' + subject_com_type_id);
}

getSubjectTemplateDocsByDocTemplateFile(doc_template_file)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/template_docs/doc_template_file/' + doc_template_file);
}

getSubjectTemplateDocsByDocThemeFile(document_base_theme_docx)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/template_docs/doc_theme_file/' + document_base_theme_docx);
}


getSubjectComTypesByDocThemeFile(document_base_theme_docx)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/com_types/document_base_theme_docx/' + document_base_theme_docx);
}





getSubjectTemplateDocsCheck(model)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/template_docs/doc_check/templates/' + model.subject_com_type_id
    + '/' + model.job_type_affidavit_type_id
    + '/' + model.job_type_court_id
    + '/' + model.job_type_location_id
    + '/' + model.job_type_id
    + '/' + model.job_type_document_type_id
    );
}

getSubjectTemplateDoc(doc_id)
{
    return this.http.get(this.$api_get_url + '/api/communication/com_types/template_doc/' + doc_id);
}

createSubjectTemplateDoc(model){
    const body = JSON.stringify(model);
    return this.http.post( this.$api_get_url + '/api/communication/com_types/template_doc/create/', body, httpOptions);
 }


 createSystemAutomation(model){
    const body = JSON.stringify(model);
    return this.http.post( this.$api_get_url + '/api/system_automation/create', body, httpOptions);
 }



updateSubjectTemplateDoc(model){
    const body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/communication/com_types/template_doc/update/' + model.doc_id, body, httpOptions);
}


updateSystemAutomation(model){
    const body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/system_automation/update/' + model.system_automation_id, body, httpOptions);
}


getSubjectTemplateDocsGrid(subject_com_type_id)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/template_docs_grid/' + subject_com_type_id);
}


getSubjectTemplateDocsGridSearch(subject_com_type_id)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/template_docs_grid/search/' + subject_com_type_id);
}

getSubjectTemplateDocsGridSearch2Passed(subject_com_type_id)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/template_docs_grid/2passed/search/' + subject_com_type_id);
}


getBrandPrimaryContact(brand_id) {
    return this.http.get(this.$api_get_url + '/api/brands/get/primary/user/' + brand_id );
}


getSystemAutomationsGrid()
{
    return this.http.get(this.$api_get_url + '/api/system_automations_grid');
}



// resolution outcomes
getSubjectServiceResolutionOutcomes()
{
    return this.http.get(this.$api_get_url + '/api/subject/services/resolution_outcomes');
}


getSubjectServiceResolutionOutcome(id){
     return this.http.get(this.$api_get_url + '/api/subject/services/resolution_outcome/' + id);
}

createSubjectServiceResolutionOutcome(model){
     const body = JSON.stringify(model);
    return this.http.post( this.$api_get_url + '/api/subject/services/resolution_outcome', body, httpOptions);
}

updateSubjectServiceResolutionOutcome(id, model){
    const body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/subject/services/resolution_outcome/' + id, body, httpOptions);
}

deleteSubjectServiceResolutionOutcome(id) {
    return this.http.delete(this.$api_get_url + '/api/subject/services/resolution_outcome/' + id );
}




// resolution outcome types

getSubjectServiceResolutionOutcomeTypes()
{
    return this.http.get(this.$api_get_url + '/api/subject/services/resolution_outcome_types');
}

getSubjectServiceResolutionOutcomesByType(subject_service_resolution_outcome_type_id){
     return this.http.get(this.$api_get_url + '/api/subject/services/resolution_outcomes_by_type/' + subject_service_resolution_outcome_type_id);
}


getSubjectServiceResolutionOutcomeTypesByType(subject_service_resolution_outcome_type_id){
     return this.http.get(this.$api_get_url + '/api/subject/services/resolution_outcome_type/' + subject_service_resolution_outcome_type_id);
}

createSubjectServiceResolutionOutcomeType(model){
    //  return this.http.post(this.$api_get_url + '/api/subject/services/resolution_outcome_type');
     const body = JSON.stringify(model);
    return this.http.post( this.$api_get_url + '/api/subject/services/resolution_outcome_type', body, httpOptions);
}

deleteSubjectServiceResolutionOutcomeType(subject_service_resolution_outcome_type_id) {
    // /api/trace/note/delete/{note_id}
    return this.http.delete(this.$api_get_url + '/api/subject/services/resolution_outcome_type/' + subject_service_resolution_outcome_type_id );
}

getSubjectServiceResolutionOutcomeTypeOutcomesCount(subject_service_resolution_outcome_type_id){
   
    return this.http.get(this.$api_get_url + '/api/subject/services/count/resolution_outcomes_by_type/' + subject_service_resolution_outcome_type_id);

}

updateSubjectServiceResolutionOutcomeType(subject_service_resolution_outcome_type_id, model){
    const body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/subject/services/resolution_outcome_type/' + subject_service_resolution_outcome_type_id, body, httpOptions);
}



// Remove all=
deleteJobPlaintiff(job_plaintiff_id) {
    return this.http.delete(this.$api_get_url + '/api/job/plaintiff/delete/' + job_plaintiff_id );
}


deleteJobSubjectDocument(job_subject_document_id) {
    return this.http.delete(this.$api_get_url + '/api/job/subject/document/delete/' + job_subject_document_id );
}

deleteJobPlaintiffs(job_id) {
    return this.http.delete(this.$api_get_url + '/api/job/plaintiffs/delete/' + job_id );
}

deleteJobReportSubjects(job_id) {
    return this.http.delete(this.$api_get_url + '/api/job/report/subjects/delete/' + job_id );
}



getJobPlaintiffs(job_id) {
    return this.http.get(this.$api_get_url + '/api/job/plaintiffs/' + job_id );
}


getJobSubjectDocumentsByJobID(job_id) {
    return this.http.get(this.$api_get_url + '/api/job/subject/documents/ByJobID/' + job_id );
}

getJobSubjectDocumentsBySubjectID(subject_id) {
    return this.http.get(this.$api_get_url + '/api/job/subject/documents/BySubjectID/' + subject_id );
}


addJobPlaintiff(model){
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/job/plaintiff/create', body, httpOptions);
   }


   addJobSubjectDocument(model){
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/job/subject/document/create', body, httpOptions);
   }
  

// Doc Model - Create File
createFile(model){
 let body = JSON.stringify(model);
return this.http.post( this.$api_get_url + '/api/file/create', body, httpOptions);
}


createNote(model){
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/note/create', body, httpOptions);
   }


updateFile(model){
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/file/update/' + model.file_id, body, httpOptions);
   }

   updateFileAssignSubjects(model, permission_model){
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/file/update/assign_subjects/' + model.file_id, body, httpOptions);
   } 


   updateNoteAssignSubjects(model, permission_model){
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/note/update/assign_subjects/' + model.note_id, body, httpOptions);
   } 




   updateJobReportSubjects(model, job_id){
  //  let body = JSON.stringify(model);
    let body = model;
  return this.http.post( this.$api_get_url + '/api/job/report/subject/create/' + job_id, body, httpOptions);
   }

   updateSubjectNoteContent(model){
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/job/subject/note/update/' + model.note_id, body, httpOptions);
   }

// Doc Model - Create File
getSystemFile(file_id){
   // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/file/get/' + file_id);
   }

   // new fuction for June 2025
   getSystemFileByName(file_name){
   // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/file/get_byname/' + file_name);
   }
   
   
   getSystemFileAssignedFrom(file_id){
    // let body = JSON.stringify(model);
    return this.http.get( this.$api_get_url + '/api/file/get/assigned_from/' + file_id);
    }
 

    getSystemNoteAssignedFrom(note_id){
        // let body = JSON.stringify(model);
        return this.http.get( this.$api_get_url + '/api/note/get/assigned_from/' + note_id);
        }
     


    getSystemNote(note_id){
        // let body = JSON.stringify(model);
        return this.http.get( this.$api_get_url + '/api/note/get/' + note_id);
        }


   getSubjectFiles(subject_id){
    // let body = JSON.stringify(model);
    return this.http.get( this.$api_get_url + '/api/subject/files/' + subject_id);
    }
 

    getJobFiles(job_id){
        // let body = JSON.stringify(model);
        return this.http.get( this.$api_get_url + '/api/job/files/' + job_id);
        }
        
    getBrandFiles(brand_id){
        // let body = JSON.stringify(model);
        return this.http.get( this.$api_get_url + '/api/brand/files/' + brand_id);
        }
     

createSystemLog(model){
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/system_log/create', body, httpOptions);
   }

createSubjectCommunicationHistory(model){
    let body = JSON.stringify(model);
  return this.http.post( this.$api_get_url + '/api/system_communication_history/create', body, httpOptions);
  }


  getSubjectCommunicationHistory(subject_id){
    // let body = JSON.stringify(model);
  return this.http.get( this.$api_get_url + '/api/get/subject_commumnication_history/' + subject_id);
  }

  getSubjectNoteCommunicationHistory(note_id){
    // let body = JSON.stringify(model);
  return this.http.get( this.$api_get_url + '/api/get/subject_commumnication_history/bynote/' + note_id);
  }

  getBrandCommunicationHistory(brand_id){
    // let body = JSON.stringify(model);
  return this.http.get( this.$api_get_url + '/api/get/brand_commumnication_history/' + brand_id);
  }
  

  getCommunicationHistory(subject_communication_history_id){
    // let body = JSON.stringify(model);
  return this.http.get( this.$api_get_url + '/api/get/commumnication_history/' + subject_communication_history_id);
  }

// combo boxes

                // observables
                getBrandsComboBox(combo_model): Observable<any> {
                    let body = JSON.stringify(combo_model);
                    return this.http.put<any>(this.$api_get_url + '/api/brandsComboBox', body, httpOptions).pipe(retry(3),
                    shareReplay()
                    );
                };





// TESTING AS OBSERVABLE subscriptions
// https://luukgruijs.medium.com/understanding-creating-and-subscribing-to-observables-in-angular-426dbf0b04a3
public fetchSystemLog() {
    return this.http.get(this.$api_get_url + '/api/system_log/list');
}

public fetchSystemLogSearch(search_model) {
    // return this.http.get(this.$api_get_url + '/api/system_log/search');
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/system_log/search', body, httpOptions);


}

public fetchSystemFiles() {
    return this.http.get(this.$api_get_url + '/api/files');
}

public fetchSystemLogCreatedBy(created_by) {
    return this.http.get(this.$api_get_url + '/api/system_log/created_by/' + created_by);
}


public getSystemLog(log_id) {
    return this.http.get(this.$api_get_url + '/api/system_log/' + log_id);
}

public getSubjectSystemLogs(subject_id) {
    return this.http.get(this.$api_get_url + '/api/system_logs/bysubject/' + subject_id);
}

public getJobSystemLogs(job_id) {
    return this.http.get(this.$api_get_url + '/api/system_logs/byjob/' + job_id);
}

public getBrandSystemLogs(brand_id) {
    return this.http.get(this.$api_get_url + '/api/system_logs/bybrand/' + brand_id);
}



public getJobFilesGrid(model) {
    let body = JSON.stringify(model);
    return this.http.put(this.$api_get_url + '/api/job/files/grid', body, httpOptions);
}


public getSubjectInvoiceFiles(invoice_id) {
    return this.http.get(this.$api_get_url + '/api/invoice/files/' + invoice_id, httpOptions);
}

public getSubjectAgentWorkOrderFiles(work_order_id, agent_id) {
    return this.http.get(this.$api_get_url + '/api/work_order/agent/files/' + work_order_id + '/' + agent_id, httpOptions);
}

// Invoicing & Accointing

getInvoices(): Observable<any> {
    return this.http.get<any>(this.$api_get_url + '/api/invoices').pipe(retry(3),
    shareReplay()
    )
};


getWorkOrders(): Observable<any> {
    return this.http.get<any>(this.$api_get_url + '/api/work-orders').pipe(retry(3),
    shareReplay()
    )
};
getPayments() {
    return this.http.get( this.$api_get_url + '/api/payments', httpOptions);
 };

 getPaymentsMetrics(search_model) {
    // return this.http.get( this.$api_get_url + '/api/payments', httpOptions);
    let body = JSON.stringify(search_model);
    return this.http.put(this.$api_get_url + '/api/payments/metrics', body, httpOptions);
 };

 getSpendingsMetrics(search_model) {
    // return this.http.get( this.$api_get_url + '/api/payments', httpOptions);
    let body = JSON.stringify(search_model);
    return this.http.put(this.$api_get_url + '/api/spendings/metrics', body, httpOptions);
 };

 getSpendings() {
    return this.http.get( this.$api_get_url + '/api/spendings', httpOptions);
 };

 getSpending(spending_id) {
    return this.http.get( this.$api_get_url + '/api/spending/' + spending_id, httpOptions);
 };

 

 getPayment(payment_id) {
    return this.http.get( this.$api_get_url + '/api/payment/' + payment_id, httpOptions);
 };

 getPaymentByInvoiceID(invoice_id) {
    return this.http.get( this.$api_get_url + '/api/payment/byInvoiceID/' + invoice_id, httpOptions);
 };

 getSpendingByWorkOrderID(work_order_id) {
    return this.http.get( this.$api_get_url + '/api/spending/byWorkOrderID/' + work_order_id, httpOptions);
 };

getSubjectInvoice(invoice_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/subject/invoice/' + invoice_id, httpOptions);
};

getSubjectInvoiceByInvoiceNumber(invoice_number) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/subject/invoice/number/' + invoice_number, httpOptions);
};


getSubjectWorkOrderByWorkOrderNumber(work_order_number) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/subject/work_order/number/' + work_order_number, httpOptions);
};

getSubjectInvoiceByUID(UID) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/subject/invoice/UID/' + UID, httpOptions);
};

getSubjectWorkOrder(work_order_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/subject/work_order/' + work_order_id, httpOptions);
};

getSubjectWorkOrderByUID(UID) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/subject/work_order/by/UID/' + UID, httpOptions);
};


updateSubjectInvoice(invoice_model) {
    let body = JSON.stringify(invoice_model);
    return this.http.post(this.$api_get_url + '/api/job/subject/invoice/update/' + invoice_model.invoice_id, body, httpOptions);
};

updateSubjectInvoiceByUID(invoice_model) {
    let body = JSON.stringify(invoice_model);
    return this.http.post(this.$api_get_url + '/api/job/subject/invoice/update/by/UID/' + invoice_model.UID, body, httpOptions);
};

updateSubjectWorkOrderByUID(work_order_model) {
    let body = JSON.stringify(work_order_model);
    return this.http.post(this.$api_get_url + '/api/job/subject/work_order/update/by/UID/' + work_order_model.UID, body, httpOptions);
};


updateSubjectWorkOrder(work_order_model) {
    let body = JSON.stringify(work_order_model);
    return this.http.post(this.$api_get_url + '/api/job/subject/work_order/update/' + work_order_model.work_order_id, body, httpOptions);
};


updateInvoiceStatus(model) {
    let body = JSON.stringify(model);
  // console.log(model);
    return this.http.post(this.$api_get_url + '/api/job/subject/invoice/status/change/' + model.invoice_id, body, httpOptions);
}


updateWorkOrderStatus(model) {
    let body = JSON.stringify(model);
  // console.log(model);
    return this.http.post(this.$api_get_url + '/api/job/subject/work_order/status/change/' + model.work_order_id, body, httpOptions);
}


updateInvoicePaymentStatus(model) {
    let body = JSON.stringify(model);
  // console.log(model);
    return this.http.post(this.$api_get_url + '/api/job/subject/invoice/payment_status/change/' + model.invoice_id, body, httpOptions);
}

updateWorkOrderPaymentStatus(model) {
    let body = JSON.stringify(model);
  // console.log(model);
    return this.http.post(this.$api_get_url + '/api/job/subject/work_order/payment_status/change/' + model.work_order_id, body, httpOptions);
}

updateInvoiceCommunicationStatus(model) {
    let body = JSON.stringify(model);
  // console.log(model);
    return this.http.post(this.$api_get_url + '/api/job/subject/invoice/communication_status/change/' + model.invoice_id, body, httpOptions);
}

updateWorkOrderCommunicationStatus(model) {
    let body = JSON.stringify(model);
  // console.log(model);
    return this.http.post(this.$api_get_url + '/api/job/subject/work_order/communication_status/change/' + model.work_order_id, body, httpOptions);
}

getSubjectInvoiceItems(invoice_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/subject/invoice/items/' + invoice_id, httpOptions);
};

getSubjectWorkOrderItems(work_order_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/subject/work_order/items/' + work_order_id, httpOptions);
};


public getInvoiceLogs(invoice_id) {
    return this.http.get(this.$api_get_url + '/api/invoice/logs/' + invoice_id);
}


public getAgentWorkOrderLogs(work_order_id, agent_id) {
    return this.http.get(this.$api_get_url + '/api/agent/work_order/logs/' + work_order_id + '/' + agent_id);
}

createSubjectInvoice(invoice_model){
    //  let body = JSON.stringify(invoice_model);
     let body = invoice_model;
    return this.http.post( this.$api_get_url + '/api/job/subject/invoice/create', body, httpOptions);
     }


     createSubjectWorkOrder(invoice_model){
        //  let body = JSON.stringify(invoice_model);
         let body = invoice_model;
        return this.http.post( this.$api_get_url + '/api/job/subject/work_order/create', body, httpOptions);
         }
    

     

addSubjectInvoiceItem(model, invoice_id){
        //  let body = JSON.stringify(model);
          let body = model;
        return this.http.post( this.$api_get_url + '/api/subject/invoice/invoice_item/create/' + invoice_id, body, httpOptions);
         }

addSubjectWorkOrderItem(model, work_order_id){
//  let body = JSON.stringify(model);
let body = model;
return this.http.post( this.$api_get_url + '/api/subject/work_order/work_order_item/create/' + work_order_id, body, httpOptions);
}         

updateSubjectInvoiceItem(model, invoice_item_id){
            //  let body = JSON.stringify(model);
              let body = model;
            return this.http.post( this.$api_get_url + '/api/job/subject/invoice/invoice_item/update/' + invoice_item_id, body, httpOptions);
  }
    

  updateSubjectInvoiceItemByDescription(model, invoice_id){
    //  let body = JSON.stringify(model);
      let body = model;
    return this.http.post( this.$api_get_url + '/api/job/subject/invoice/invoice_item/update/by/description/' + invoice_id, body, httpOptions);
}

updateSubjectWorkOrderItemByDescription(model, work_order_id){
    //  let body = JSON.stringify(model);
      let body = model;
    return this.http.post( this.$api_get_url + '/api/job/subject/work_order/work_order_item/update/by/description/' + work_order_id, body, httpOptions);
}

  updateSubjectWorkOrderItem(model, work_order_item_id){
    //  let body = JSON.stringify(model);
      let body = model;
    return this.http.post( this.$api_get_url + '/api/job/subject/work_order/work_order_item/update/' + work_order_item_id, body, httpOptions);
}

getSubjectInvoices(subject_id) {
            //let body = JSON.stringify(model);
           return this.http.get( this.$api_get_url + '/api/job/subject/invoices/' + subject_id, httpOptions);
        };

        getBrandInvoices(to_brand_id) {
            //let body = JSON.stringify(model);
           return this.http.get( this.$api_get_url + '/api/brand/invoices/' + to_brand_id, httpOptions);
        };

        getBrandInvoicesClientOnly(to_brand_id) {
            //let body = JSON.stringify(model);
           return this.http.get( this.$api_get_url + '/api/brand/invoices/client_only/' + to_brand_id, httpOptions);
        };


        getBrandWorkOrders(agent_id) {
            //let body = JSON.stringify(model);
           return this.http.get( this.$api_get_url + '/api/brand/work_orders/' + agent_id, httpOptions);
        };


        getBrandWorkOrdersAgentOnly(agent_id) {
            //let body = JSON.stringify(model);
           return this.http.get( this.$api_get_url + '/api/brand/work_orders/agent_only/' + agent_id, httpOptions);
        };



        getBrandInvoices2(brand_id) {
            //let body = JSON.stringify(model);
           return this.http.get( this.$api_get_url + '/api/brand/subject/invoices/' + brand_id, httpOptions);
        };


getJobInvoices(job_id) {
            //let body = JSON.stringify(model);
           return this.http.get( this.$api_get_url + '/api/job/invoices/' + job_id, httpOptions);
        };        

        checkForJobInvoice(job_id) {
            //let body = JSON.stringify(model);
           return this.http.get( this.$api_get_url + '/api/job/invoices/check/is_job_invoice/' + job_id, httpOptions);
        };        


getSubjectWorkOrders(subject_id) {
            //let body = JSON.stringify(model);
           return this.http.get( this.$api_get_url + '/api/job/subject/work_orders/' + subject_id, httpOptions);
        };        

    getSubjectAgentWorkOrders(subject_id, agent_id) {
            //let body = JSON.stringify(model);
           return this.http.get( this.$api_get_url + '/api/job/subject/agent/work_orders/' + subject_id + '/' + agent_id, httpOptions);
        };                
         


getBillingTasks() {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/billing_tasks', httpOptions);
};

getCostTasks() {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/cost_tasks', httpOptions);
};


getBillingTask(billing_task_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/billing_task/' + billing_task_id, httpOptions);
};



getCostTask(cost_task_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/cost_task/' + cost_task_id, httpOptions);
};


getSubjectBillingItems(subject_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/subject/billing_items/' + subject_id, httpOptions);
};


getAppRouteBillingItem(app_route_billing_item_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/route/billing_item/' + app_route_billing_item_id, httpOptions);
};

getJobBillingItems(job_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/billing_items/' + job_id, httpOptions);
};

getAppRouteBillingItems(app_route_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/route/billing_items/' + app_route_id, httpOptions);
};


getBrandBillingItems(brand_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/brand/billing_items/' + brand_id, httpOptions);
};

getJobCostItems(job_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/cost_items/' + job_id, httpOptions);
};

getBrandCostItems(brand_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/brand/cost_items/' + brand_id, httpOptions);
};



getSubjectCostItems(subject_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/subject/cost_items/' + subject_id, httpOptions);
};


createBillingTask(model){
    //  let body = JSON.stringify(model);
      let body = model;
    return this.http.post( this.$api_get_url + '/api/billing_task/create', body, httpOptions);
     }

updateBillingTask(model){
//  let body = JSON.stringify(model);
    let body = model;
return this.http.post( this.$api_get_url + '/api/billing_task/update/' + model.billing_task_id, body, httpOptions);
    }


    updateAppRouteBillingItem(model){
        //  let body = JSON.stringify(model);
            let body = model;
        return this.http.post( this.$api_get_url + '/api/route/billing_item/update/' + model.app_route_billing_item_id, body, httpOptions);
            }   

    updateCostTask(model){
        //  let body = JSON.stringify(model);
            let body = model;
        return this.http.post( this.$api_get_url + '/api/cost_task/update/' + model.cost_task_id, body, httpOptions);
            }
        

     
createCostTask(model){
    //  let body = JSON.stringify(model);
      let body = model;
    return this.http.post( this.$api_get_url + '/api/cost_task/create', body, httpOptions);
     }


     

addSubjectBillingItem(model){
    //  let body = JSON.stringify(model);
      let body = model;
    return this.http.post( this.$api_get_url + '/api/subject/billing_item/create', body, httpOptions);
     }

addAppRouteBillingItem(model){
        //  let body = JSON.stringify(model);
          let body = model;
        return this.http.post( this.$api_get_url + '/api/route/billing_item/create', body, httpOptions);
         }     

addSubjectCostItem(model){
        //  let body = JSON.stringify(model);
          let body = model;
        return this.http.post( this.$api_get_url + '/api/subject/cost_item/create', body, httpOptions);
         }    

deleteSubjectInvoiceItem(model, invoice_item_id) {
        return this.http.delete(this.$api_get_url + '/api/job/subject/invoice/invoice_item/delete/' + invoice_item_id );
    };

    deleteSubjectWorkOrderItem(model, work_order_item_id) {
        return this.http.delete(this.$api_get_url + '/api/job/subject/work_order/work_order_item/delete/' + work_order_item_id );
    };


deleteSubjectBillingItem(subject_billing_item_id) {
        return this.http.delete(this.$api_get_url + '/api/subject/billing_item/delete/' + subject_billing_item_id );
    };  

    deleteAppRouteBillingItem(app_route_billing_item_id) {
        return this.http.delete(this.$api_get_url + '/api/route/billing_item/delete/' + app_route_billing_item_id );
    };     
    
    deleteSubjectAllBillingItems(subject_id) {
        return this.http.delete(this.$api_get_url + '/api/subject/billing_items/delete/' + subject_id );
    };    

    deleteSubjectCostItem(subject_cost_item_id) {
        return this.http.delete(this.$api_get_url + '/api/subject/cost_item/delete/' + subject_cost_item_id );
    };    

    deleteSubjectAllCostItems(subject_id) {
        return this.http.delete(this.$api_get_url + '/api/subject/cost_items/delete/' + subject_id );
    };    



    deleteSubject(subject_id) {
        return this.http.delete(this.$api_get_url + '/api/job/subject/delete/' + subject_id );
    };  
    
    deleteJob(job_id) {
        return this.http.delete(this.$api_get_url + '/api/job/delete/' + job_id );
    };  
    
    deleteSubjectNotes(subject_id) {
        return this.http.delete(this.$api_get_url + '/api/subject/notes/delete/' + subject_id );
    };    
    
    deleteJobNotes(job_id) {
        return this.http.delete(this.$api_get_url + '/api/job/notes/delete/' + job_id );
    };    

    deleteSubjectFiles(subject_id) {
        return this.http.delete(this.$api_get_url + '/api/subject/files/delete/' + subject_id );
    };    
    


updateSubjectBillingItem(model, subject_billing_item_id) {
        //  let body = JSON.stringify(model);
          let body = model;
        return this.http.post( this.$api_get_url + '/api/subject/billing_item/update/' + subject_billing_item_id, body, httpOptions);
         }

updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number, invoice_model) {
//  let body = JSON.stringify(model);
 let body = invoice_model;
return this.http.post( this.$api_get_url + '/api/subject/billing_item/update/invoice_status/'
+ invoice_status + '/' + subject_billing_item_id + '/' + invoice_id + '/' + invoice_number, body, httpOptions);
}


updateSubjectCostItemWorkOrderStatus(work_order_status, subject_cost_item_id, work_order_id, work_order_number) {
    //  let body = JSON.stringify(model);
    //  let body = model;
    return this.http.post( this.$api_get_url + '/api/subject/cost_item/update/work_order_status/'
    + work_order_status + '/' + subject_cost_item_id + '/' + work_order_id + '/' + work_order_number, httpOptions);
    }

updateSubjectCostItemWorkOrderStatusAgentID(work_order_status, subject_cost_item_id, work_order_id, work_order_number, agent_id, work_order_model) {
        //  let body = JSON.stringify(model);
         let body = work_order_model;
        return this.http.post( this.$api_get_url + '/api/subject/cost_item/update/work_order_status_agent/'
        + work_order_status + '/' + subject_cost_item_id + '/' + work_order_id + '/' + work_order_number + '/' + agent_id, body, httpOptions);
        }

updateSubjectCostItemInvoiceStatus(work_order_status, subject_cost_item_id, work_order_id, work_order_number) {
//  let body = JSON.stringify(model);
//  let body = model;
return this.http.post( this.$api_get_url + '/api/subject/cost_item/update/work_order_status/'
+ work_order_status + '/' + subject_cost_item_id + '/' + work_order_id + '/' + work_order_number, httpOptions);
}


getMyobAccountCodes() {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/myob_account_codes', httpOptions);
};



getMyobTaxCodes() {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/myob_tax_codes', httpOptions);
};


checkForLocalMyobAccountUID(UID) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/search/myob_account_codes/by/' + UID, httpOptions);
}

getInvoiceStatus(invoice_status_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/invoice/invoice_status/' + invoice_status_id, httpOptions);
};

getWorkOrderStatus(work_order_status_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/work_order/work_order_status/' + work_order_status_id, httpOptions);
};


getInvoicePaymentStatus(invoice_payment_status_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/invoice/invoice_payment_status/' + invoice_payment_status_id, httpOptions);
};

getWorkOrderPaymentStatus(work_order_payment_status_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/work_order/work_order_payment_status/' + work_order_payment_status_id, httpOptions);
};


getInvoiceCommunicationStatus(invoice_communication_status_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/invoice/invoice_communication_status/' + invoice_communication_status_id, httpOptions);
};

getWorkOrderCommunicationStatus(work_order_communication_status_id) {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/work_order/work_order_communication_status/' + work_order_communication_status_id, httpOptions);
};


getInvoiceStatusAll() {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/invoice/invoice_status/all', httpOptions);
};

getWorkOrderStatusAll() {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/work_order/work_order_status/all', httpOptions);
};

getInvoicePaymentStatusAll() {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/invoice/invoice_payment_status/all', httpOptions);
};

getWorkOrderPaymentStatusAll() {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/work_order/work_order_payment_status/all', httpOptions);
};

getInvoiceCommunicationStatusAll() {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/invoice/invoice_communication_status/all', httpOptions);
};

getWorkOrderCommunicationStatusAll() {
    //let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/work_order/work_order_communication_status/all', httpOptions);
};



createPayment(model){
    //  let body = JSON.stringify(model);
      let body = model;
    return this.http.post( this.$api_get_url + '/api/payment/create', body, httpOptions);
     }


updatePayment(model){
        //  let body = JSON.stringify(model);
          let body = model;
        return this.http.post( this.$api_get_url + '/api/payment/update/' + model.payment_id, body, httpOptions);
    }



         updateSpending(model){
            //  let body = JSON.stringify(model);
              let body = model;
            return this.http.post( this.$api_get_url + '/api/spending/update/' + model.spending_id, body, httpOptions);
             }
    


     createSpending(model){
        //  let body = JSON.stringify(model);
          let body = model;
        return this.http.post( this.$api_get_url + '/api/spending/create', body, httpOptions);
         }
    
 
         createMyobAccountCodes(model){
             let body = JSON.stringify(model);
            //   let body = model;
            return this.http.post( this.$api_get_url + '/api/accounts/myob_account_codes/import/create/all', body, httpOptions);
             }

        updateMyobAccountCodes(model, myob_account_code_id ){
                let body = JSON.stringify(model);
               //   let body = model;
               return this.http.post( this.$api_get_url + '/api/accounts/myob_account_codes/update/' + myob_account_code_id, body, httpOptions);
                }

        createMyobTaxCodes(model){
            let body = JSON.stringify(model);
            //   let body = model;
            return this.http.post( this.$api_get_url + '/api/accounts/myob_tax_codes/import/create/all', body, httpOptions);
            }

        updateMyobTaxCodes(model, myob_tax_code_id ){
                let body = JSON.stringify(model);
                //   let body = model;
                return this.http.post( this.$api_get_url + '/api/accounts/myob_tax_codes/update/' + myob_tax_code_id, body, httpOptions);
                }




     
createSubjectInvoicePayment(model, payment_id){
    //  let body = JSON.stringify(model);
      let body = model;
    return this.http.post( this.$api_get_url + '/api/job/subject/invoice_payment/create/' + payment_id, body, httpOptions);
     }


updateSubjectInvoicePayment(model, invoice_payment_id){
        //  let body = JSON.stringify(model);
          let body = model;
        return this.http.post( this.$api_get_url + '/api/job/subject/invoice_payment/updateitem/' + invoice_payment_id, body, httpOptions);
         }
        


     createSubjectWorkOrderPayment(model, spending_id){
        //  let body = JSON.stringify(model);
          let body = model;
        return this.http.post( this.$api_get_url + '/api/job/subject/work_order_payment/create/' + spending_id, body, httpOptions);
         }
    

    updateSubjectWorkOrderPayment(model, work_order_payment_id){
    //  let body = JSON.stringify(model);
        let body = model;
    return this.http.post( this.$api_get_url + '/api/job/subject/work_order_payment/updateitem/' + model.work_order_payment_id, body, httpOptions);
        }
    


updateInvoiceAfterPaymentFigures(model) {
         let body = JSON.stringify(model);
         // let body = model;
        return this.http.post( this.$api_get_url + '/api/job/subject/invoice/update/figures/afterpayment', body, httpOptions);
         }



         updateWorkOrderAfterPaymentFigures(model) {
            let body = JSON.stringify(model);
            // let body = model;
           return this.http.post( this.$api_get_url + '/api/job/subject/work_order/update/figures/afterpayment', body, httpOptions);
            }
   
   


getInvoicePayments(invoice_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/subject/invoice_payments/' + invoice_id, httpOptions);
};


getInvoicePaymentsByPaymentID(payment_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/subject/invoice_payments/byPaymentID/' + payment_id, httpOptions);
};


getWorkOrderSpendingsBySpendingID(spending_id, work_order_id?) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/subject/work_order_spendings/bySpendingID/' + spending_id , httpOptions);
};



// getWorkOrderSpendingsBySpendingID(spending_id, work_order_id) {
//     // let body = JSON.stringify(model);
//    return this.http.get( this.$api_get_url + '/api/job/subject/work_order_spendings/bySpendingID/' + spending_id + '/' + work_order_id, httpOptions);
// };


getInvoicePaymentsByPaymentIDInvoiceID(payment_id, invoice_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/subject/invoice_payments/byPaymentID/' + payment_id + '/' + invoice_id, httpOptions);
};

getWorkOrderPayments(work_order_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/subject/work_order_payments/' + work_order_id, httpOptions);
};


getWorkOrderPaymentsALl() {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/subject/all/work_order_payments', httpOptions);
};

getJobServiceRules() {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/service_rules', httpOptions);
};

getJobServiceRule(job_service_rule_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/service_rule/' + job_service_rule_id, httpOptions);
};

updateJobServiceRule(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/job/service_rule/update/' + model.job_service_rule_id, body, httpOptions);
}


updateJobServiceTimeframe(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/job/service_timeframe/update/' + model.job_service_timeframe_id, body, httpOptions);
}


deleteJobServiceRule(job_service_rule_id) {
    return this.http.delete(this.$api_get_url + '/api/job/service_rule/delete/' + job_service_rule_id );
};    



getDocumentServiceRules(job_type_document_type_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/document/service_rules/grid/' + job_type_document_type_id, httpOptions);
};



getJobServiceTimeframes() {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/service_timeframes', httpOptions);
};

getJobServiceTimeframe(job_service_timeframe_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/service_timeframe/get/' + job_service_timeframe_id, httpOptions);
};

getSubjectServiceTypes() {
    return this.http.get(this.$api_get_url + '/api/job/subject/service_types/all');
}


getTimeframeSurcharges() {
    return this.http.get(this.$api_get_url + '/api/timeframe-surcharges');
}

createSubjectServiceType(model) {
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/job/subject/service_type/create', body, httpOptions);
}

getSubjectServiceType(subject_service_type_id)
{
    return this.http.get(this.$api_get_url + '/api/job/subject/service_type/' + subject_service_type_id);
}


getTimeframeSurcharge(timeframe_surcharge_id)
{
    return this.http.get(this.$api_get_url + '/api/timeframe-surcharge/' + timeframe_surcharge_id);
}

updateSubjectServiceType(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/job/subject/service_type/update/' + model.subject_service_type_id, body, httpOptions);
}


updateTimeframeSurcharges(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/timeframe-surcharge/update/' + model.timeframe_surcharge_id, body, httpOptions);
}


createTimeframeSurcharges(model) {
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/job/timeframe-surcharge/create', body, httpOptions);
}

getReportAgentMetricsServices(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/report/agent-metrics/services', body, httpOptions);
   }



   getJobServiceMetricsSubjectSearch(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/report/job/service/metrix/search', body, httpOptions);
   }


   getJobServiceMetricsSubjectSearchActivity(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/report/job/service/metrix/search/activity', body, httpOptions);
   }


   getJobServiceMetricsSubjectSearchActivityCounts(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/report/job/service/metrix/search/activity/counts', body, httpOptions);
   }

   getAgentActivityMetricsV2(search_model: ActivityMetricsV2Search): Observable<ActivityMetricsV2Response> {
    const body = JSON.stringify(search_model);
    return this.http.put<ActivityMetricsV2Response>(this.$api_get_url + '/api/report/activity/agent/v2', body, httpOptions);
   }

   exportAgentActivityMetricsV2(search_model: ActivityMetricsV2Search): Observable<ActivityMetricsV2ExportResponse> {
    const body = JSON.stringify(search_model);
    return this.http.put<ActivityMetricsV2ExportResponse>(this.$api_get_url + '/api/report/activity/agent/v2/export', body, httpOptions);
   }

   setupAgentActivityMetricsV2Store(payload: any = {}): Observable<ActivityMetricsV2StoreSetupResponse> {
    const body = JSON.stringify(payload);
    return this.http.put<ActivityMetricsV2StoreSetupResponse>(this.$api_get_url + '/api/report/activity/agent/v2/store/setup', body, httpOptions);
   }

   getAgentActivityMetricsV2StoreStatus(search_model?: ActivityMetricsV2Search | null): Observable<ActivityMetricsV2StoreStatus> {
    if (search_model) {
      const body = JSON.stringify(search_model);
      return this.http.put<ActivityMetricsV2StoreStatus>(this.$api_get_url + '/api/report/activity/agent/v2/store/status', body, httpOptions);
    }

    return this.http.get<ActivityMetricsV2StoreStatus>(this.$api_get_url + '/api/report/activity/agent/v2/store/status');
   }

   syncAgentActivityMetricsV2Store(search_model: ActivityMetricsV2Search): Observable<ActivityMetricsV2StoreSyncResponse> {
    const body = JSON.stringify(search_model);
    return this.http.put<ActivityMetricsV2StoreSyncResponse>(this.$api_get_url + '/api/report/activity/agent/v2/store/sync', body, httpOptions);
   }

   cleanupAgentActivityMetricsV2Store(payload: any): Observable<ActivityMetricsV2StoreCleanupResponse> {
    const body = JSON.stringify(payload);
    return this.http.put<ActivityMetricsV2StoreCleanupResponse>(this.$api_get_url + '/api/report/activity/agent/v2/store/cleanup', body, httpOptions);
   }


   getSubjectCommunicationHistorySearchFull(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/report/subject_communication_history/metrix/search', body, httpOptions);
   }

   getSubjectNotesSearchFull(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/system/subject/notes/search', body, httpOptions);
   }


   

   getJobSubjectAttendancesCountNumber(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/get/job/subject/service/count/service_number', body, httpOptions);
   }

// need a new quiery to take out count if outcome types is_count != 1

   getJobSubjectAttendances2CountNumber(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/get/job/subject/attendance/count/service_number', body, httpOptions);
   }

   getAgentJobSubjects(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/get/agent/job/subjects', body, httpOptions);
   }

   createPrimaryUser(model){
    //  let body = JSON.stringify(model);
      let body = model;
    return this.http.post( this.$api_get_url + '/api/brand/client/user/create', body, httpOptions);
     }

// :: @ Subject Contact Emails
     getSubjectContactEmails(subject_id) {
        // let body = JSON.stringify(model);
       return this.http.get( this.$api_get_url + '/api/job/subject/contact_emails/' + subject_id, httpOptions);
    };

    deleteSubjectContactEmail(subject_contact_email_id) {
        return this.http.delete(this.$api_get_url + '/api/job/subject/contact_email/delete/' + subject_contact_email_id, httpOptions2);
     }

     deleteSubjectContactEmails(subject_id) {
        return this.http.delete(this.$api_get_url + '/api/job/subject/contact_emails/delete/' + subject_id, httpOptions2);
     }


     createSubjectContactEmail(model){
        //  let body = JSON.stringify(model);
          let body = model;
        return this.http.post( this.$api_get_url + '/api/job/subject/contact_email/create', body, httpOptions);
         }

    editSubjectContactEmail(model){
            //  let body = JSON.stringify(model);
              let body = model;
            return this.http.put( this.$api_get_url + '/api/job/subject/contact_email/update/' + model.subject_contact_email_id, body, httpOptions);
             }

getSubjectContactEmail(subject_contact_email_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/subject/contact_email/' + subject_contact_email_id, httpOptions);
};


// :: @ Subject Contact Numbers
getSubjectContactNumbers(subject_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/job/subject/contact_numbers/' + subject_id, httpOptions);
};

deleteSubjectContactNumber(subject_contact_number_id) {
    return this.http.delete(this.$api_get_url + '/api/job/subject/contact_number/delete/' + subject_contact_number_id, httpOptions2);
 }

 deleteSubjectContactNumbers(subject_id) {
    return this.http.delete(this.$api_get_url + '/api/job/subject/contact_numbers/delete/' + subject_id, httpOptions2);
 }

 deleteMyobTaxCode(myob_tax_code_id) {
    return this.http.delete(this.$api_get_url + '/api/myob/taxcode/delete/' + myob_tax_code_id, httpOptions2);
 }
 deleteMyobAccountCode(myob_account_code_id) {
    return this.http.delete(this.$api_get_url + '/api/myob/accountcode/delete/' + myob_account_code_id, httpOptions2);
 }

 deleteBillingTask(billing_task_id) {
    return this.http.delete(this.$api_get_url + '/api/billingtask/delete/' + billing_task_id, httpOptions2);
 }

 deleteCostTask(cost_task_id) {
    return this.http.delete(this.$api_get_url + '/api/costtask/delete/' + cost_task_id, httpOptions2);
 }

 createSubjectContactNumber(model){
    //  let body = JSON.stringify(model);
      let body = model;
    return this.http.post( this.$api_get_url + '/api/job/subject/contact_number/create', body, httpOptions);
     }

editSubjectContactNumber(model){
        //  let body = JSON.stringify(model);
          let body = model;
        return this.http.put( this.$api_get_url + '/api/job/subject/contact_number/update/' + model.subject_contact_number_id, body, httpOptions);
         }

getSubjectContactNumber(subject_contact_number_id) {
// let body = JSON.stringify(model);
return this.http.get( this.$api_get_url + '/api/job/subject/contact_number/' + subject_contact_number_id, httpOptions);
};



deleteSystemFileAssigned(model) {
    return this.http.delete(this.$api_get_url + '/api/file/delete/assinged_from_file_id/' + model.file_id, httpOptions);
    
 }

 deleteSystemFile(model) {
    return this.http.delete(this.$api_get_url + '/api/file/delete/system_file/' + model.file_id + '/' + model.assigned_from_file_id, httpOptions);
    
 }


 deleteSystemNote(note_id, assigned_from_note_id) {
    return this.http.delete(this.$api_get_url + '/api/note/delete/system_note/' + note_id + '/' + assigned_from_note_id, httpOptions);
    
 }

 deletePaymentAndInvoicePayment(model) {
    return this.http.delete(this.$api_get_url + '/api/allpaymentdata/delete/' + model.payment_id + '/' + model.invoice_id, httpOptions);
 }

 deletePaymentAndWorkOrderPayment(model) {
    return this.http.delete(this.$api_get_url + '/api/allpaymentdata/work_order/delete/'
     + model.spending_id + '/' + model.work_order_id, httpOptions);
 }

 // New Search Queries
 searchJS(term, limit){
    const apiRootJobSubjects = this.$api_get_url + '/api/job/subject/search'; //
    const  apiRootJobSubjects_Global = this.$api_get_url + '/api/job/subject/global/search';
    const apiURLJS = `${apiRootJobSubjects}/${term}/20002`;
    // const apiURLJS = apiRootJobSubjects + '/' + term + '/' + limit;
    return this.http.get( apiURLJS, httpOptions);


 }


 // Remove a single when checked (as a put)
deleteSubjectTemplateDoc(doc_id) {
   // let body = JSON.stringify(item);
    // console.log(model);
     return this.http.delete(this.$api_get_url + '/api/subject_template_docs/delete/' + doc_id, httpOptions);
}


deleteSystemAutomation(system_automation_id) {
    // let body = JSON.stringify(item);
     // console.log(model);
      return this.http.delete(this.$api_get_url + '/api/system_automation/delete/' + system_automation_id, httpOptions);
 }
 

// NEW 2023 FEB MYOB SYNC CHECHS SAME CHECKS AS THE NODE FUNCTIONS RUNS TO GET OUTSTANDINGS.


getPendingClients() {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/brands/clients/new/sync_with_myob/1', httpOptions);
};

getPendingAgents() {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/brands/agents/new/sync_with_myob/1', httpOptions);
};


getPendingClientsInvoices() {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/invoices/new/invoice_status/3', httpOptions);
};


getPendingAgentsInvoices() {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/work_orders/new/work_order_status/3', httpOptions);
};



getPendingClientsInvoicesPayments() {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/payments/approved/for/myob', httpOptions);
};

getPendingAgentsInvoicesPayments() {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/spendings/approved/for/myob', httpOptions);
}



getSystemLogTypes() {
    return this.http.get(this.$api_get_url + '/api/system_log_types');
   // return this.http.get('https://digitalgoblet.com/slim-crud/public/api/user_levels');
}

getSystemLogTypeDataSectorTypes() {
    return this.http.get(this.$api_get_url + '/api/system_log_type_data_sector_types');
   // return this.http.get('https://digitalgoblet.com/slim-crud/public/api/user_levels');
}


getSystemLogTypeDataSectorConditions() {
    return this.http.get(this.$api_get_url + '/api/system_log_type_data_sector_conditions');
   // return this.http.get('https://digitalgoblet.com/slim-crud/public/api/user_levels');
}






updateSystemLogType(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/system_log_type/update/' + model.log_type_id, body, httpOptions);
}

updateSystemLogTypeDataSectorType(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/system_log_type_data_sector_type/update/' + model.log_type_data_sector_type_id, body, httpOptions);
}

updateSystemLogTypeDataSectorCondition(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/system_log_type_data_sector_condition/update/' + model.log_type_data_sector_condition_id, body, httpOptions);
}


updateSystemLogTypeDataSector(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/system_log_type_data_sector/update/' + model.log_type_data_sector_id, body, httpOptions);
}

updateSubjectServiceOutcomeTemplate(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/subject_service_outcome_template/update/' + model.ssot_id, body, httpOptions);
}

updateSubjectUrgentOutcomeTemplate(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/subject_urgent_outcome_template/update/' + model.suot_id, body, httpOptions);
}


getSystemLogType(log_type_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/system_log_type/' + log_type_id, httpOptions);
};

getSystemLogTypeDataSectorType(log_type_data_sector_type_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/system_log_type_data_sector_type/' + log_type_data_sector_type_id, httpOptions);
};

getSystemLogTypeDataSectorCondition(log_type_data_sector_condition_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/system_log_type_data_sector_condition/' + log_type_data_sector_condition_id, httpOptions);
};


getSystemLogTypeDataSector(log_type_data_sector_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/system_log_type_data_sector/' + log_type_data_sector_id, httpOptions);
};


getSubjectServiceOutcomeTemplate(ssot_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/subject_service_outcome_template/' + ssot_id, httpOptions);
};

getSubjectUrgentOutcomeTemplate(suot_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/subject_urgent_outcome_template/' + suot_id, httpOptions);
};



getSystemLogTypeDataSectors() {
    // let body = JSON.stringify(model);
    return this.http.get( this.$api_get_url + '/api/system_log_types/log-type-data-sectors', httpOptions);
};


getSubjectServicesOutcomeTemplates() {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/subject-services-outcome-templates', httpOptions);
};

getSubjectUrgentOutcomeTemplates() {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/subject-urgent-outcome-templates', httpOptions);
};


getSystemLogLevels() {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/get/system_log_levels', httpOptions);
};

// PPS DistroHub

createActionList(model)
{
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_url + '/api/pps/action/list/create', body, httpOptions);
    /// Maybe get the vars here and then rediect the page from the actual component.
}

getActionLists()
{
    // let body = JSON.stringify(model);
    // return this.http.post(this.$api_get_url + '/api/pps/action/list/create', body, httpOptions);
    // /// Maybe get the vars here and then rediect the page from the actual component.
    return this.http.get(this.$api_get_url + '/api/pps/action/lists', httpOptions);
}
getActionList(action_list_id)
{
    // let body = JSON.stringify(model);
    // return this.http.post(this.$api_get_url + '/api/pps/action/list/create', body, httpOptions);
    // /// Maybe get the vars here and then rediect the page from the actual component.
    return this.http.get(this.$api_get_url + '/api/pps/action/list/' + action_list_id, httpOptions);
}
getActionListByName(action_list_name)
{
    // let body = JSON.stringify(model);
    // return this.http.post(this.$api_get_url + '/api/pps/action/list/create', body, httpOptions);
    // /// Maybe get the vars here and then rediect the page from the actual component.
    return this.http.get(this.$api_get_url + '/api/pps/action/listbyname/' + action_list_name, httpOptions);
}
deleteActionList(action_list_id)
{
    // let body = JSON.stringify(model);
    // return this.http.post(this.$api_get_url + '/api/pps/action/list/create', body, httpOptions);
    // /// Maybe get the vars here and then rediect the page from the actual component.
    return this.http.delete(this.$api_get_url + '/api/pps/action/list/delete/' + action_list_id, httpOptions);
}

getSystemLogsArray(model)
{
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_url + '/api/pps/action/listbyarray', body, httpOptions);
    /// Maybe get the vars here and then rediect the page from the actual component.
}


getSystemAutomationsArray(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_url + '/api/system/automations/listbyarray', body, httpOptions);
}

getSystemResolutionsArray(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_url + '/api/system/resolutions/listbyarray', body, httpOptions);
}

getSystemSubjectTemplateDocsArray(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_url + '/api/system/subject_template_docs/listbyarray', body, httpOptions);
}


getJobSubjectsArray(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_url + '/api/job/subjects/listbyarray', body, httpOptions);
}

getSystemSubjectTemplateDocsArray_Communications(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_url + '/api/system/subject_template_docs_communications/listbyarray', body, httpOptions);
}


getSystemSubjectTemplateDocsArray_Conditions(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_url + '/api/system/system_log_type_data_sector_conditions/listbyarray', body, httpOptions);
}

getSystemAutomationLogTypeTriggersByArray(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_url + '/api/system/automations/log/Types/listbyarray', body, httpOptions);
}



getNoteTypes() {
    return this.http.get(this.$api_get_url + '/api/note/types');
}

getNoteType(note_type_id) {
    return this.http.get(this.$api_get_url + '/api/note/type/' + note_type_id );
}






// PPS Promotions
getPromotions()
{
    // let body = JSON.stringify(model);
    // return this.http.post(this.$api_get_url + '/api/pps/action/list/create', body, httpOptions);
    // /// Maybe get the vars here and then rediect the page from the actual component.
    return this.http.get(this.$api_get_url + '/api/pps/promotions', httpOptions);
}


createPromotion(model)
{
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_url + '/api/pps/promotion/create', body, httpOptions);
    /// Maybe get the vars here and then rediect the page from the actual component.
}

updatePromotion(model){
    //  let body = JSON.stringify(model);
      let body = model;
    return this.http.put( this.$api_get_url + '/api/pps/promotion/update/' + model.promotion_id, body, httpOptions);
     }
getPromotion(promotion_id)
{
    // let body = JSON.stringify(model);
    // return this.http.post(this.$api_get_url + '/api/pps/action/list/create', body, httpOptions);
    // /// Maybe get the vars here and then rediect the page from the actual component.
    return this.http.get(this.$api_get_url + '/api/pps/promotion/' + promotion_id, httpOptions);
}



getVariableCodeBlocks()
{
    // let body = JSON.stringify(model);
    // return this.http.post(this.$api_get_url + '/api/pps/action/list/create', body, httpOptions);
    // /// Maybe get the vars here and then rediect the page from the actual component.
    return this.http.get(this.$api_get_url + '/api/variable-code-blocks', httpOptions);
}
getVariableCodeBlocksSearchFull(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/variable-code-blocks/metrix/search', body, httpOptions);
   }


   getDataSectorConditionsSearchFull(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/data-sector-conditions/metrix/search', body, httpOptions);
   }

createVariableCodeBlock(model) {
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/variable-code-block/create', body, httpOptions);
}
getVariableCodeBlock(variable_code_block_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/variable-code-block/' + variable_code_block_id, httpOptions);
};
updateVariableCodeBlock(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/variable-code-block/update/' + model.variable_code_block_id, body, httpOptions);
};
deleteVariableCodeBlock(variable_code_block_id) {
    return this.http.delete(this.$api_get_url + '/api/variable-code-block/delete/' + variable_code_block_id );
}
getVariableCodeBlockTypes() {
    return this.http.get(this.$api_get_url + '/api/variable-code-block-types');
}
getVariableCodeBlockTypesActive() {
    return this.http.get(this.$api_get_url + '/api/variable-code-block-types-active');
}
deletePromotion(promotion_id) {
    return this.http.delete(this.$api_get_url + '/api/promotion/delete/' + promotion_id );
}
getVariableCodeBlockInsertTypes() {
    return this.http.get(this.$api_get_url + '/api/variable-code-block-insert-types');
}

getAppRoutesSearchFull(search_model){
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/app-routes/metrix/search', body, httpOptions);
   } 
   getAppRoute(app_route_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/app-route/' + app_route_id, httpOptions);
};


//:: Routes Per Project -- Each Project Now has seperate Routes and Conditions and Numbering Systems.
getProjectBaseRouteCount(model) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/project/app-route/base_route/count/' + model.project_id, httpOptions);
};


getProjectBaseRouteChildCount(model) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/project/app-route/base_route/child/count/' + model.project_id + '/' + model.app_route_id + '/' + model.file_number, httpOptions);
};


getProjectTaskRouteChildCount(model) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/project/app-route/task_route/child/count/' + model.project_id + '/' + model.app_route_id + '/' + model.file_number + '/' + model.app_route_number, httpOptions);
};



getAppRouteTypes() {
    return this.http.get(this.$api_get_url + '/api/app-route-types');
}

getAppRouteTypesActive() {
    return this.http.get(this.$api_get_url + '/api/app-route-types-active');
}

getAppRoutes() {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/system_routes/app_routes', httpOptions);
};

getAppRoutesWithChildren() {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/system_routes/app_routes-with-children', httpOptions);
};



getAppRouteInsertTypes() {
    return this.http.get(this.$api_get_url + '/api/app-route-insert-types');
}
updateAppRoute(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/app-route/update/' + model.app_route_id, body, httpOptions);
};

createAppRoute(model) {
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/app-route/create', body, httpOptions);
}
deleteAppRoute(app_route_id) {
    return this.http.delete(this.$api_get_url + '/api/app-route/delete/' + app_route_id );
}


// @ :: Stort of N Projects
getProjects(){
    return this.http.get(this.$api_get_url + '/api/projects');
   } 

   getProject(project_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/project/' + project_id, httpOptions);
};

getProjectRoutes(project_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/project/routes/' + project_id, httpOptions);
};



updateProject(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/project/update/' + model.project_id, body, httpOptions);
}


updateProjectFigures(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/project-figures/update/' + model.project_id, body, httpOptions);
}


// Adobe API


encryptPDF_FTP_Backvault(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_adobeAPI + '/encrypt/PDF/so/ftp/' + model.full_file_name, body, httpOptions);
 } // end class
  
 encryptPDF_FTP_AdobeAPI(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_adobeAPI + '/encrypt/PDF/so/ftp/' + model.full_file_name, body, httpOptions);
 } // end class
   


 // Custom JSON user route logger

 route_log(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/route/log', body, httpOptions);
}

route_log_staff(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/route/log/staff', body, httpOptions);
}

route_log_client(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/route/log/client', body, httpOptions);
}


route_log_agent(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/route/log/agent', body, httpOptions);
}


 getJsonIP(){

 return this.http.get( 'https://jsonip.com', httpOptions);

    //  this.http.get<{ip:string}>('https://jsonip.com')
    //           .subscribe( data => {
    //             // console.log('th data', data);
    //             this.ipAddress = data
    //           })
 }

// benchmarks


getSystemLogTypeBenchmarks(model) {
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_url + '/api/system_log_type_benchmarks', body, httpOptions);
   // return this.http.get('https://digitalgoblet.com/slim-crud/public/api/user_levels');
}



createSystemLogTypeBenchmark(model) {
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/system_log_type_benchmark/create', body, httpOptions);
}


getSystemLogTypeBenchmark(log_type_benchmark_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/system_log_type_benchmark/' + log_type_benchmark_id, httpOptions);
};

updateSystemLogTypeBenchmark(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/system_log_type_benchmark/update/' + model.log_type_benchmark_id, body, httpOptions);
}

deleteSystemLogTypeBenchmark(log_type_benchmark_id) {
    return this.http.delete(this.$api_get_url + '/api/system_log_type_benchmark/delete/' + log_type_benchmark_id, httpOptions2);
 }


 getSystemLogTypesWithBenchmarks() {
    return this.http.get(this.$api_get_url + '/api/system_log_types/with/benchmarks');
   // return this.http.get('https://digitalgoblet.com/slim-crud/public/api/user_levels');
}


getSystemLogTypesWithBenchmarksStaff() {
    return this.http.get(this.$api_get_url + '/api/system_log_types/with/benchmarks/staff');
   // return this.http.get('https://digitalgoblet.com/slim-crud/public/api/user_levels');
}


getSystemLogTypesWithBenchmarksAgent() {
    return this.http.get(this.$api_get_url + '/api/system_log_types/with/benchmarks/agent');
   // return this.http.get('https://digitalgoblet.com/slim-crud/public/api/user_levels');
}

getSystemLogTypesWithBenchmarksClient() {
    return this.http.get(this.$api_get_url + '/api/system_log_types/with/benchmarks/client');
   // return this.http.get('https://digitalgoblet.com/slim-crud/public/api/user_levels');
}


public fetchSystemLogSearchActivity(search_model) {
    // return this.http.get(this.$api_get_url + '/api/system_log/search');
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/system_log/search/activity', body, httpOptions);
}

public fetchSystemLogSearchActivityStaff(search_model) {
    // return this.http.get(this.$api_get_url + '/api/system_log/search');
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/system_log/search/activity/staff', body, httpOptions);
}


public fetchStaffAchievements(search: StaffAchievementSearch): Observable<StaffAchievementReport> {
    return this.http.put<StaffAchievementReport>(this.$api_get_url + '/api/system_log/search/activity/staff/achievements', search, httpOptions);
}

public fetchStaffWeightedWork(search: StaffWeightedWorkSearch): Observable<StaffWeightedWorkReport> {
    return this.http.put<StaffWeightedWorkReport>(this.$api_get_url + '/api/system_log/search/activity/staff/weighted-work', search, httpOptions);
}

public fetchSystemLogSearchActivityStaff2(search_model) {
    // return this.http.get(this.$api_get_url + '/api/system_log/search');
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/system_log/search/activity/staff2', body, httpOptions);
}


getBenchmarkKpiGroups() {
    return this.http.get(this.$api_get_url + '/api/benchmark/kpi/groups');
   // return this.http.get('https://digitalgoblet.com/slim-crud/public/api/user_levels');
}

getBenchmarkKpiGroup(benchmark_kpi_group_id) {
    // let body = JSON.stringify(model);
   return this.http.get( this.$api_get_url + '/api/benchmark/kpi/group/' + benchmark_kpi_group_id, httpOptions);
};

getBenchmarkKpiGroupLogTypesArray(model){
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_url + '/api/benchmark/kpi/group/log-type-groups/listbyarray', body, httpOptions);
}

updateSBenchmarkKpiGroup(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/benchmark/kpi/group/update/' + model.benchmark_kpi_group_id, body, httpOptions);
}


saveStaffMetricsData(model){
    let body = JSON.stringify(model);
    return this.http.post( this.$api_get_url + '/api/metrics/staff/save', body, httpOptions);

 } // end class

 saveAgentMetricsData(model){
    let body = JSON.stringify(model);
    return this.http.post( this.$api_get_url + '/api/metrics/agent/save', body, httpOptions);

 } // end class


 saveAgentAttemptsMetricsData(model){
    let body = JSON.stringify(model);
    return this.http.post( this.$api_get_url + '/api/metrics/agent/attempts/save', body, httpOptions);

 } // end class


 saveClientMetricsData(model){
    let body = JSON.stringify(model);
    return this.http.post( this.$api_get_url + '/api/metrics/client/save', body, httpOptions);

 } // end class

 getSavedStaffMetricsDataFile() {
    return this.http.get(this.$api_get_url + '/api/metrics/staff/saved-files');
}

getSelectedStaffMetricsDataFiles(selectedFiles: string[]) {
    return this.http.post(this.$api_get_url + '/api/metrics/staff/saved-files/selected', selectedFiles);
}


public fetchSystemLogSearchActivityAgent(search_model) {
    // return this.http.get(this.$api_get_url + '/api/system_log/search');
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/system_log/search/activity/agent', body, httpOptions);
}


public fetchSystemLogSearchActivityClient(search_model) {
    // return this.http.get(this.$api_get_url + '/api/system_log/search');
    let body = JSON.stringify(search_model);
       return this.http.put(this.$api_get_url + '/api/system_log/search/activity/client', body, httpOptions);
}

getSubjectServiceBenchmarks()
{
    return this.http.get(this.$api_get_url + '/api/subject/service/benchmarks');
}

getSubjectServiceBenchmarksById(subject_service_benchmark_id)
{
    return this.http.get(this.$api_get_url + '/api/subject/service/benchmarks/ByID/' + subject_service_benchmark_id);
}

updateSubjectServiceBenchmark(model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/subject/service/benchmars/update/' + model.subject_service_benchmark_id, body, httpOptions);
}



getSystemDBEncyptionStatus(){
    // let body = JSON.stringify(model);
    return this.http.get( this.$api_get_url + '/api/encryption/status');
    }
 

    // getSystemDBEncyptionStatus(): Observable<any> {
    //     return this.http.get(`${this.$api_get_url}/api/encryption/status`);
    //   }
      
      verifyDBEncryptionSettings(): Observable<any> {
        return this.http.get(`${this.$api_get_url}/api/encryption/verify`);
      }
      
      encryptSchema(schemaName: string): Observable<any> {
        return this.http.post(`${this.$api_get_url}/api/encryption/schema/${schemaName}`, {});
      }
      
      encryptTable(schemaName: string, tableName: string): Observable<any> {
        return this.http.post(`${this.$api_get_url}/api/encryption/table/${schemaName}/${tableName}`, {});
      }



      getEncryptionReport(): Observable<any> {
        return this.http.get(`${this.$api_get_url}/api/encryption/report`);
      }





      // notices
      getSystemNotice(id)
{
    return this.http.get(this.$api_get_url + '/api/system_notice/' + id);
}
getSystemNotices()
{
    return this.http.get(this.$api_get_url + '/api/system_notices');
}

// getSystemNoticesByRoute(route){
//     return this.http.post(`${this.$api_get_url}/api/system_notices/route`, route, httpOptions);
// }

getSystemNoticesByRoute(payload: any) {
    return this.http.post(this.$api_get_url +  '/api/system_notices/route', payload);
  }

createSystemNotice(model)
{
    let body = JSON.stringify(model);
    return this.http.post(this.$api_get_url + '/api/system_notice/create', body, httpOptions);
    /// Maybe get the vars here and then rediect the page from the actual component.
}

updateSystemNotice(id, model){
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/system_notice/update/' + id, body, httpOptions);

}

// New function to check for duplicated job reference numbers. // algarith in mysql ??? I dont know yet
duplicateJobReferenceLookup(model){
    let body = JSON.stringify(model);
    // return this.http.post(this.$api_get_url +  '/api/job/reference/check/' + model.owner_trace_code  + '/1000', model); // changed to get from body
    return this.http.post(this.$api_get_url +  '/api/job/reference/check/1000', body, httpOptions);

}

//all
getSubjectsUrgentExportJobSchedules() {
    return this.http.get(this.$api_get_url + '/api/subjects_urgent_schedules');
}

createSubjectsUrgentExportJobSchedule(model) {
    let body = JSON.stringify(model);
   return this.http.post( this.$api_get_url + '/api/subjects_urgent_schedule', body, httpOptions);
}

getSubjectsUrgentExportJobSchedule(id) {
    return this.http.get(this.$api_get_url + '/api/subjects_urgent_schedule/' + id);
}

updateSubjectsUrgentExportJobSchedule(model) {
    let body = JSON.stringify(model);
   return this.http.put( this.$api_get_url + '/api/subjects_urgent_schedule/' + model.id, body, httpOptions);
}


deleteSubjectsUrgentExportJobSchedule(id) {
return this.http.delete(this.$api_get_url + '/api/subjects_urgent_schedule/' + id, httpOptions2);
}


// create the default base client code 4/3 barnd name suburb
createBrandClientCode(brand_id) {
    return this.http.put(this.$api_get_url + '/api/brand/update/client_code/'  + brand_id, httpOptions );
}

// All at once run once?
createBrandClientCodesAll() {
    return this.http.put(this.$api_get_url + '/api/brands/update/client_codes/all', httpOptions );
}




}
